import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import pugilatoPalombaraImg from '../assets/pugilato_palombara.png';
import pugilatoSgurgolaImg from '../assets/pugilato_sgurgola.jpg';
import locandina19GiugnoImg from '../assets/Locandina_19_giugno_2023.jpg';
import programmaGaucherPdf from '../assets/Programma_Evento_Roma_ 02 Luglio_2025.pdf';
import locandina18OttobreImg from '../assets/Locandina_RobinHood_evento_18_ottobre 2025-1.png';
import locandinaCorsoVolontariImg from '../assets/locandina_corso_volontari.png';
import locandina7MarzoImg from '../assets/locandina-7-marzo.png';
import video7MarzoMp4 from '../assets/Canale_14_digitale_terrestre_evento_7_marzo_2026.mp4';
import videoOrienteering from '../assets/VIDEO_EVENTO_ORIENTEERING.mp4';
import immagineEvento6GiugnoImg from '../assets/immagine-evento-6-giungo.png';
import locandina6GiugnoPdf from '../assets/LOCANDINA_EVENTO_6_6_2026.pdf';
import logoPremioStregaImg from '../assets/logo-premio-strega.png';
import robinPremioStregaImg from '../assets/robin-premio-strega.png';
import premioStregaFoto1 from '../assets/premio-strega-2026-foto-1.jpg';
import premioStregaFoto2 from '../assets/premio-strega-2026-foto-2.jpg';

// Foto evento 7 marzo 2026
import foto7Mar1 from '../assets/evento-7-marzo/Foto_1.jpeg';
import foto7Mar2 from '../assets/evento-7-marzo/Foto_2.jpeg';
import foto7Mar3 from '../assets/evento-7-marzo/Foto_3.jpeg';
import foto7Mar4 from '../assets/evento-7-marzo/Foto_4.jpeg';
import foto7Mar5 from '../assets/evento-7-marzo/Foto_5.jpeg';
import foto7Mar6 from '../assets/evento-7-marzo/Foto_6.jpeg';
import foto7Mar7 from '../assets/evento-7-marzo/Foto_7.jpeg';
import foto7Mar8 from '../assets/evento-7-marzo/Foto_8.jpeg';
import foto7Mar9 from '../assets/evento-7-marzo/Foto_9.jpeg';
import foto7Mar10 from '../assets/evento-7-marzo/Foto_10.jpeg';
import foto7Mar11 from '../assets/evento-7-marzo/Foto_11.jpeg';
import foto7Mar12 from '../assets/evento-7-marzo/Foto_12.jpeg';
import foto7Mar13 from '../assets/evento-7-marzo/Foto_13.jpeg';
import foto7Mar14 from '../assets/evento-7-marzo/Foto_14.jpeg';
import foto7Mar15 from '../assets/evento-7-marzo/Foto_15.jpeg';
import foto7Mar16 from '../assets/evento-7-marzo/Foto_16.jpeg';
import foto7Mar17 from '../assets/evento-7-marzo/Foto_17.jpeg';
import foto7Mar18 from '../assets/evento-7-marzo/Foto_18.jpeg';
import foto7Mar19 from '../assets/evento-7-marzo/Foto_19.jpeg';
import foto7Mar20 from '../assets/evento-7-marzo/Foto_20.jpeg';
import foto7Mar21 from '../assets/evento-7-marzo/Foto_21.jpeg';
import foto7Mar22 from '../assets/evento-7-marzo/Foto_22.jpeg';
import foto7Mar23 from '../assets/evento-7-marzo/Foto_23.jpeg';
import foto7Mar24 from '../assets/evento-7-marzo/Foto_24.jpeg';
import foto7Mar25 from '../assets/evento-7-marzo/Foto_25.jpeg';

// Foto evento 18 ottobre 2025
import foto18Ott1 from '../assets/evento-18-ottobre/PA181517.JPG';
import foto18Ott2 from '../assets/evento-18-ottobre/PA181522.JPG';
import foto18Ott3 from '../assets/evento-18-ottobre/PA181525.JPG';
import foto18Ott4 from '../assets/evento-18-ottobre/PA181529.JPG';
import foto18Ott5 from '../assets/evento-18-ottobre/PA181540.JPG';
import foto18Ott6 from '../assets/evento-18-ottobre/PA181568.JPG';
import foto18Ott7 from '../assets/evento-18-ottobre/PA181581.JPG';
import foto18Ott8 from '../assets/evento-18-ottobre/PA181611.JPG';
import foto18Ott9 from '../assets/evento-18-ottobre/PA181613.JPG';
import foto18Ott10 from '../assets/evento-18-ottobre/PA181618.JPG';
import foto18Ott11 from '../assets/evento-18-ottobre/PA181621.JPG';
import foto18Ott12 from '../assets/evento-18-ottobre/PA181642.JPG';
import foto18Ott13 from '../assets/evento-18-ottobre/PA181653.JPG';
import foto18Ott14 from '../assets/evento-18-ottobre/PA181670.JPG';

// Foto Mercatino Solidale dicembre 2025
import mercatinoSolidale1 from '../assets/Mercatino_solidale_1.jpeg';
import mercatinoSolidale2 from '../assets/Mercatino_solidale_2.JPG';
import mercatinoSolidale3 from '../assets/Mercatino_solidale_3.jpeg';
import mercatinoSolidale4 from '../assets/Mercatino_solidale_4.JPG';

// Foto Cena di beneficenza Palestrina 19 dicembre 2025
import cenaPalestrina19Dic from '../assets/Foto Evento 19 dicembre 2025.jpg';

// Calendar data for awareness days
const awarenessEvents = [
  {
    id: 1,
    title: "Giornata mondiale delle Malattie Rare",
    date: new Date(new Date().getFullYear(), 1, 28), // Feb 28 (Month is 0-indexed)
    description: "Una giornata dedicata alla sensibilizzazione sulle malattie rare, che si celebra l'ultimo giorno di febbraio (28 o 29 negli anni bisestili).",
    color: "bg-blue-500",
    type: "day"
  },
  {
    id: 2,
    title: "Giornata mondiale della Depressione",
    date: new Date(new Date().getFullYear(), 3, 7), // Apr 7
    description: "Una giornata per aumentare la consapevolezza sulla depressione, una condizione che colpisce milioni di persone globalmente.",
    color: "bg-purple-500",
    type: "day"
  },
  {
    id: 3,
    title: "Giornata mondiale dell'Emofilia",
    date: new Date(new Date().getFullYear(), 3, 17), // Apr 17
    description: "Una giornata dedicata alla sensibilizzazione sull'emofilia, altri deficit congeniti dei fattori della coagulazione e la Malattia di Von Willebrand.",
    color: "bg-red-500",
    type: "day"
  },
  {
    id: 4,
    title: "Giornata mondiale della Talassemia",
    date: new Date(new Date().getFullYear(), 4, 8), // May 8
    description: "Una giornata per aumentare la consapevolezza sulla talassemia, una malattia genetica che colpisce la produzione di emoglobina.",
    color: "bg-orange-500",
    type: "day"
  },
  {
    id: 5,
    title: "Settimana mondiale dell'Emocromatosi",
    date: new Date(new Date().getFullYear(), 5, 1), // Jun 1-7
    endDate: new Date(new Date().getFullYear(), 5, 7),
    description: "Una settimana dedicata all'emocromatosi, un disturbo che causa l'accumulo eccessivo di ferro nell'organismo.",
    color: "bg-amber-600",
    type: "week"
  },
  {
    id: 6,
    title: "Giornata mondiale dell'Anemia di Fanconi",
    date: new Date(new Date().getFullYear(), 5, 14), // Jun 14
    description: "Una giornata dedicata alla sensibilizzazione sull'Anemia di Fanconi, una rara malattia genetica che colpisce il midollo osseo.",
    color: "bg-pink-500",
    type: "day"
  },
  {
    id: 7,
    title: "Giornata mondiale dell'Anemia a cellule falciformi",
    date: new Date(new Date().getFullYear(), 5, 19), // Jun 19
    description: "Una giornata dedicata alla drepanocitosi (anemia a cellule falciformi), una malattia genetica che colpisce i globuli rossi.",
    color: "bg-red-600",
    type: "day"
  },
  {
    id: 8,
    title: "Giornata mondiale della Porpora trombotica trombocitopenica",
    date: new Date(new Date().getFullYear(), 6, 5), // Jul 5
    description: "Una giornata dedicata alla sensibilizzazione sulla Porpora trombotica trombocitopenica, un disturbo raro del sangue.",
    color: "bg-indigo-500",
    type: "day"
  },
  {
    id: 9,
    title: "Giornata mondiale della Malattia di Castleman",
    date: new Date(new Date().getFullYear(), 6, 23), // Jul 23
    description: "Una giornata dedicata alla Malattia di Castleman, un raro disturbo linfoproliferativo che può colpire singoli o multipli linfonodi.",
    color: "bg-green-600",
    type: "day"
  },
  {
    id: 10,
    title: "Giornata mondiale della Donazione di midollo osseo",
    date: new Date(new Date().getFullYear(), 8, 21), // Sep 21
    description: "Una giornata per sensibilizzare sull'importanza della donazione di midollo osseo, cruciale per molti pazienti con malattie del sangue.",
    color: "bg-teal-500",
    type: "day"
  },
  {
    id: 11,
    title: "Settimana mondiale della Piastrinopenia immune",
    date: new Date(new Date().getFullYear(), 8, 23), // Sep 23-27
    endDate: new Date(new Date().getFullYear(), 8, 27),
    description: "Una settimana dedicata alla piastrinopenia immune, un disturbo caratterizzato da un basso numero di piastrine nel sangue.",
    color: "bg-cyan-600",
    type: "week"
  },
  {
    id: 12,
    title: "Giornata mondiale della Malattia di Gaucher",
    date: new Date(new Date().getFullYear(), 9, 1), // Oct 1
    description: "Una giornata dedicata alla Malattia di Gaucher, un disturbo metabolico ereditario raro.",
    color: "bg-emerald-500",
    type: "day"
  },
  {
    id: 13,
    title: "Giornata mondiale della Emoglobinuria parossistica notturna",
    date: new Date(new Date().getFullYear(), 9, 12), // Oct 12
    description: "Una giornata dedicata all'Emoglobinuria parossistica notturna, una rara malattia acquisita del sangue.",
    color: "bg-violet-600",
    type: "day"
  },
  {
    id: 14,
    title: "Giornata mondiale della Trombosi",
    date: new Date(new Date().getFullYear(), 9, 13), // Oct 13
    description: "Una giornata dedicata alla sensibilizzazione sulla trombosi e sui disordini ereditari trombofilici.",
    color: "bg-rose-600",
    type: "day"
  },
  {
    id: 15,
    title: "Giornata mondiale della Mastocitosi",
    date: new Date(new Date().getFullYear(), 9, 20), // Oct 20
    description: "Una giornata dedicata alla mastocitosi e ai disordini mastocitari, condizioni rare che comportano un accumulo anomalo di mastociti.",
    color: "bg-fuchsia-500",
    type: "day"
  },
  {
    id: 16,
    title: "Giornata mondiale delle Sindromi mieloidisplastiche",
    date: new Date(new Date().getFullYear(), 9, 25), // Oct 25
    description: "Una giornata dedicata alle sindromi mielodisplastiche, un gruppo di disturbi che colpiscono la produzione delle cellule del sangue.",
    color: "bg-sky-600",
    type: "day"
  },
  {
    id: 17,
    title: "Giornata mondiale dell'Amiloidosi",
    date: new Date(new Date().getFullYear(), 9, 26), // Oct 26
    description: "Una giornata dedicata all'amiloidosi primaria e familiare, un gruppo di malattie rare caratterizzate dall'accumulo di proteine anomale negli organi.",
    color: "bg-lime-600",
    type: "day"
  },
  {
    id: 18,
    title: "Giornata Mondiale delle Malattie Rare Senza Diagnosi",
    date: new Date(new Date().getFullYear(), 3, 30), // April 30 (Month is 0-indexed)
    description: "Una giornata per focalizzare l'attenzione sulle sfide affrontate dai pazienti con malattie rare che non hanno ancora ricevuto una diagnosi.",
    color: "bg-cyan-500",
    type: "day"
  }
];

const monthNames = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

const dayNames = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];

// Past events data
const pastEvents = [
  {
    id: 10,
    title: "Robin Hood Roma ODV nella giuria del Premio Strega 2026",
    date: "Edizione 2026",
    location: "Premio Strega",
    website: "https://premiostrega.it",
    description: "Partecipare alla Giuria dei Lettori del Premio Strega 2026 è stato molto più che esprimere un voto: da quel percorso è nata una vera comunità di lettori.",
    color: "bg-red-700",
    fullDescription: `<p class="text-accent font-bold text-lg mb-4">Premio Strega 2026: quando la lettura diventa comunità</p>
<p class="mb-4">Partecipare, come Gruppo di Lettura dell’Associazione Robin Hood Roma ODV, alla Giuria dei Lettori del <strong>Premio Strega 2026</strong> (<a href="https://www.premiostrega.it/" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">https://www.premiostrega.it/</a>) ha rappresentato molto più della possibilità di esprimere un voto sul più importante riconoscimento letterario italiano. È stato un percorso di confronto, di crescita e di condivisione che ha dimostrato come la lettura possa diventare un autentico strumento di inclusione e di partecipazione.</p>
<p class="mb-4">Questa esperienza è nata grazie alla scelta della <strong>Fondazione Maria e Goffredo Bellonci</strong> (<a href="https://www.fondazionebellonci.it/" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">https://www.fondazionebellonci.it/</a>), in particolare del suo Direttore <strong>Stefano Petrocchi</strong> di aprire il Premio Strega anche al nostro gruppo di lettura. Una scelta che ha trovato nella Presidente del Comitato Direttivo del Premio Strega 2026, <strong>Melania G. Mazzucco</strong>, una convinta promotrice e sostenitrice, nella consapevolezza che la letteratura possa essere uno straordinario strumento di dialogo, inclusione e crescita personale, anche nei momenti di maggiore fragilità.</p>
<div class="flex flex-col items-center gap-4 my-6">
<img src="${premioStregaFoto1}" alt="Premio Strega 2026 – la firma delle copie" class="w-full max-w-lg h-auto rounded-lg shadow-md object-contain" />
<img src="${premioStregaFoto2}" alt="Premio Strega 2026 – un momento dell’incontro" class="w-full max-w-xs h-auto rounded-lg shadow-md object-contain" />
</div>
<p class="mb-4">Il nostro Gruppo di Lettura, composto da volontari, medici, pazienti ricoverati e non ricoverati, soci, sostenitori e amici dell’Associazione, residenti in diverse regioni italiane e anche all’estero – ha vissuto un’esperienza che è andata ben oltre la dimensione del premio letterario. I libri sono diventati i fili di una rete di relazioni nella quale la lettura ha rappresentato il collante, mentre il contributo di ciascun partecipante ha arricchito il confronto con sensibilità, esperienze e punti di vista differenti.</p>
<p class="mb-4">La lettura della Dozzina e, successivamente, della Sestina finalista è stata accompagnata da nove incontri online, durante i quali ogni partecipante ha potuto condividere impressioni, interpretazioni e riflessioni grazie alla guida dell’esperto facilitatore, <strong>Claudio Cherin</strong>. Discussioni spesso proseguite ben oltre il tempo previsto, a testimonianza di quanto il dialogo tra persone con percorsi di vita diversi possa trasformarsi in un’occasione di autentico arricchimento reciproco.</p>
<p class="mb-4">Particolarmente preziosa è stata la possibilità di commentare la registrazione delle presentazioni dei sei finalisti a Benevento integrate dalle interviste agli autori disponibili su Rai Cultura. Un’opportunità che ha consentito ai giurati di maturare una conoscenza più approfondita dei libri e un giudizio ancora più consapevole.</p>
<p class="mb-4">Al termine del percorso, il risultato più importante non è stato soltanto aver partecipato alla Giuria di un premio letterario importante, ma aver visto nascere una vera comunità di lettori, confermando come i libri possano creare legami, favorire il dialogo e contribuire alla crescita culturale e umana delle persone.</p>
<p class="mb-4">Robin Hood Roma ODV desidera esprimere la propria più sincera gratitudine alla <strong>Fondazione Maria e Goffredo Bellonci</strong>, al Direttore <strong>Stefano Petrocchi</strong> e alla Presidente del Comitato Direttivo del Premio Strega 2026, <strong>Melania G. Mazzucco</strong>, per aver creduto nel valore di questa apertura e per aver offerto anche alla nostra Associazione l’opportunità di vivere un’esperienza destinata a lasciare un segno profondo.</p>
<p class="mb-4">L’esperienza della Giuria dei Lettori si conclude, ma il cammino del nostro Gruppo di Lettura continua. Perché i libri, quando diventano occasione di incontro e di ascolto reciproco, non si limitano a raccontare storie: costruiscono relazioni, rafforzano il senso di comunità, aiutano a superare la solitudine e l’isolamento di chi vive la difficile esperienza della malattia e continuano a generare valore ben oltre l’ultima pagina.</p>
<p class="mb-0 mt-6">La Presidente<br />Fiorina Giona</p>`,
    flyerImage: logoPremioStregaImg,
    modalImage: robinPremioStregaImg,
    images: [],
    videos: [],
  },
  {
    id: 9,
    title: "OrientiAMOci Insieme!",
    date: "6 giugno 2026",
    time: "10:00 - 14:00",
    location: "Roma - Villa Torlonia, Ingresso Via Siracusa (punto di ritrovo)",
    description: "IL GIRO DI VILLA TORLONIA – UNA MAPPA, MILLE SCOPERTE. Una splendida giornata all’insegna dello sport, della natura e della partecipazione attiva ha animato Villa Torlonia.",
    color: "bg-emerald-700",
    fullDescription: `<p class="font-bold text-center mb-4">OrientiAMOci Insieme!</p><p class="font-bold text-center mb-6">IL GIRO DI VILLA TORLONIA– UNA MAPPA, MILLE SCOPERTE</p><p class="mb-4">Una splendida giornata all’insegna dello sport, della natura e della partecipazione attiva ha animato Villa Torlonia, uno dei parchi storici più affascinanti di Roma, noto per i suoi ampi spazi verdi e i suggestivi percorsi immersi nel paesaggio della villa.</p><p class="mb-4">L’iniziativa di orienteering ha coinvolto partecipanti di tutte le età in un’esperienza educativa e coinvolgente che ha saputo unire movimento, spirito di squadra e scoperta del territorio. Muniti di mappe e bussola, i partecipanti si sono cimentati nella ricerca delle varie postazioni disseminate nel parco.</p><p class="mb-4">L’evento è stato caratterizzato da un’atmosfera accogliente e inclusiva creata dai volontari, grazie ai quali, con il loro impegno, l’iniziativa si è trasformata in un’importante occasione di socializzazione, favorendo l’incontro tra persone diverse e promuovendo valori come il rispetto dell’ambiente, la solidarietà e la cittadinanza attiva.</p><p class="mb-4">Particolarmente apprezzata è stata la possibilità di vivere Villa Torlonia in modo originale.</p><p class="mb-4">Al termine della giornata, la soddisfazione e l’entusiasmo dei partecipanti hanno confermato il successo dell’iniziativa. L’evento ha rappresentato un esempio concreto di come il volontariato possa creare occasioni di crescita personale e collettiva, contribuendo a rafforzare il senso di comunità e a valorizzare gli spazi pubblici attraverso attività sane, divertenti e culturalmente stimolanti.</p><p class="mb-0">Un sentito ringraziamento va a tutti i volontari, agli organizzatori e ai partecipanti che, con il loro contributo, hanno reso questa esperienza un momento speciale da ricordare e da riproporre in futuro.</p>`,
    flyerImage: immagineEvento6GiugnoImg,
    programLink: locandina6GiugnoPdf,
    downloadFileName: "Locandina_OrientiAMOci_Insieme_6_giugno_2026.pdf",
    images: [],
    videos: [],
  },
  {
    id: 8,
    title: "La malattia non è tutta la storia… Vite in movimento: storie di cura e di ciò che ci fa battere il cuore",
    date: "7 marzo 2026",
    time: "15:30",
    location: "Albergo Etico, Via Pisanelli 39, Roma",
    description: "Un incontro dedicato alle storie che nascono intorno alla cura, alla resilienza e alla forza delle relazioni. Un momento di ascolto e condivisione per ricordare che la cura è fatta anche di parole, musica e passioni.",
    fullDescription: `<p>Ci sono storie che nascono dal dolore ma non vi restano prigioniere. Storie che camminano, cambiano forma, diventano incontro, relazione, futuro. È da questo sentire profondo che nasce l'evento <strong>"LA MALATTIA NON È TUTTA LA STORIA – Vite in movimento: storie di cura e di ciò che ci fa battere il cuore"</strong>. L'evento si inserisce nel progetto <strong>"Storie di Impatto"</strong>, uno spazio di condivisione, presente nel sito (<a href="https://robinhoodroma.org/chi-siamo" style="color:#E63129;text-decoration:underline;">https://robinhoodroma.org/chi-siamo</a>) dove le esperienze difficili non vengono negate, ma accolte e trasformate.</p>

<p>All'inizio dell'incontro, la Presidente dell'Associazione ha aggiornato sui progetti in corso e proposti quelli in fase di sviluppo.</p>

<p>Per quanto riguarda i progetti in corso, il <strong>Progetto ADAMTS13</strong>, con un impegno oneroso di 50.000 euro l'anno e finalizzato a garantire una diagnosi tempestiva e un monitoraggio adeguato per i pazienti affetti da <strong>porpora trombotica trombocitopenica</strong>, dopo 6 mesi il Policlinico non ha ancora accettato la nostra richiesta di finanziamento per l'acquisto dei reagenti.</p>

<p>Un secondo progetto, il <strong>Programma Yoga</strong>, ideato e coordinato da Mario Cistulli, è stato avviato nel mese di novembre in due reparti di Ematologia. Si tratta di un'iniziativa innovativa, che ha riscosso il gradimento dei pazienti, la prima in Italia in questo ambito.</p>

<p>Il terzo progetto riguarda la realizzazione di <strong>Vademecum informativi chiari e accessibili</strong>, utili per accompagnare pazienti e familiari nel percorso di cura con terapie complesse come le terapie con CAR-T o il trapianto di cellule staminali emopoietiche.</p>

<p>Per approfondimenti sui progetti in corso: <a href="https://robinhoodroma.org/storie-iniziative" style="color:#E63129;text-decoration:underline;">https://robinhoodroma.org/storie-iniziative</a></p>

<p>Tra le iniziative future sono inoltre previsti:</p>
<ul style="list-style-type:disc;padding-left:1.5rem;margin:0.5rem 0;">
  <li>la creazione di una <strong>sezione giovani</strong> rivolta ai ragazzi tra i 14 e i 35 anni;</li>
  <li>iniziative per rendere <strong>più accoglienti e partecipati gli spazi di attesa degli ambulatori</strong>;</li>
  <li>il potenziamento della <strong>comunicazione e della presenza sui social</strong>.</li>
</ul>

<p>Ha quindi preso la parola la giornalista <strong>Paola Zanoni</strong> che ha sottolineato l'importanza della prevenzione per le neoplasie e che ha dialogato con <strong>Monica Oriente</strong>, autrice del libro <strong>"Quattro volte me"</strong> (Ed. Piemme). Nel corso della presentazione del libro l'autrice, con un linguaggio intenso e sincero ha fatto emergere emozioni sul suo percorso di vita in cui ha incontrato quattro volte il cancro. Non ha avuto paura di mettere in luce i momenti di fragilità ma anche la forza interiore che le ha permesso di affrontare le avversità con spirito di resilienza e utilizzandole come strumenti di rinascita.</p>

<p>Spazio poi a <strong>"Cinque voci, cinque storie"</strong>, una narrazione condivisa in cui le esperienze hanno preso voce e significato attraverso uno sguardo nuovo, guidato da <strong>Silvia Finocchi</strong>, psicologa e psicoterapeuta:</p>
<ul style="list-style-type:disc;padding-left:1.5rem;margin:0.5rem 0;">
  <li><strong>Monica Oriente</strong>, con il suo libro <em>Quattro volte me</em>, ha raccontato come la scrittura le abbia permesso di ricordare che la malattia è solo una parte della storia di una persona e che nessuno dovrebbe sentirsi solo nel proprio cammino.</li>
  <li><strong>Marco Marziali</strong>, autore de <em>Il donatore di musica</em>, ha sottolineato come medicina, musica e scrittura possano incontrarsi nella comprensione della persona. La scienza osserva e cura il corpo, mentre l'arte aiuta a comprendere e ascoltare l'esperienza umana della malattia.</li>
  <li><strong>Emiliano Battazzi</strong>, con <em>Calcio liquido – L'evoluzione tattica della serie A</em>, ha raccontato il calcio come un linguaggio capace di riflettere i cambiamenti della società. Attraverso il racconto sportivo, ha sottolineato, è possibile sviluppare uno sguardo più attento e consapevole sul presente, cogliendo nei gesti del gioco trasformazioni culturali e sociali.</li>
  <li><strong>Mario Cistulli</strong>, autore di <em>Educazione fisica nella scuola in ospedale</em>, ha portato la testimonianza di un approccio educativo che integra corpo, cura e relazione. L'attività motoria, adattata alle condizioni dei pazienti e condivisa con l'équipe medica, diventa uno strumento per recuperare fiducia, motivazione e un rapporto positivo con il proprio corpo.</li>
  <li><strong>Luca Laurenti</strong>, con <em>Lockdown fase 1 – diario di 55 giorni</em>, ha ricordato come il tempo sospeso della pandemia abbia insegnato a riscoprire il valore delle piccole cose quotidiane. Il suo diario vuole conservare la memoria di quel periodo, non solo per raccontarne la fragilità, ma anche la capacità delle persone di cercare senso e speranza anche nei momenti più difficili.</li>
</ul>

<p>Le testimonianze hanno mostrato come esperienze diverse possano raccontare, da prospettive differenti, la stessa verità: <strong>la vita è sempre più grande della malattia</strong>. Per saperne di più sulle 5 storie e i loro autori: <a href="https://robinhoodroma.org/chi-siamo-storie" style="color:#E63129;text-decoration:underline;">https://robinhoodroma.org/chi-siamo-storie</a></p>

<p>Ad accompagnare le parole, le <strong>"Note tra le storie"</strong> di <strong>Marco Marziali</strong> al pianoforte: un dialogo delicato tra musica ed emozioni.</p>

<p>Il messaggio più importante emerso dalla giornata è che l'esperienza della malattia può essere una parte del percorso, ma non è mai tutta la storia, perché <strong>la storia continua nelle persone, nei legami, nella capacità di immaginare ancora il futuro</strong>.</p>`,
    color: "bg-accent",
    flyerImage: locandina7MarzoImg,
    images: [foto7Mar1, foto7Mar2, foto7Mar3, foto7Mar4, foto7Mar5, foto7Mar6, foto7Mar7, foto7Mar8, foto7Mar9, foto7Mar10, foto7Mar11, foto7Mar12, foto7Mar13, foto7Mar14, foto7Mar15, foto7Mar16, foto7Mar17, foto7Mar18, foto7Mar19, foto7Mar20, foto7Mar21, foto7Mar22, foto7Mar23, foto7Mar24, foto7Mar25],
    videos: [video7MarzoMp4],
  },
  {
    id: 7,
    title: "Cena di beneficenza a Palestrina: un gesto concreto di solidarietà",
    date: "19 dicembre 2025",
    location: "Locale Scacco Matto, Palestrina",
    description: `Cena di beneficenza a Palestrina: un gesto concreto di solidarietà

Il 19 dicembre 2025, presso il locale Scacco Matto di Palestrina, si è svolta una cena di beneficenza a sostegno della nostra Associazione. Grazie alla partecipazione e alla generosità di tutti i presenti, è stato possibile raccogliere <strong>2.000 euro</strong>, un contributo prezioso per portare avanti le nostre attività.

Un ringraziamento speciale a <strong>Camilla Evangelisti</strong>, che con sensibilità e impegno ha organizzato la serata, offrendo una testimonianza autentica di affetto e solidarietà.

Un sentito grazie anche a <strong>Vittorio Tufi</strong>, per aver messo gratuitamente a disposizione il locale e la cena, contribuendo in modo decisivo alla riuscita dell'iniziativa.

I fondi raccolti permetteranno di continuare a sostenere bambini e adulti affetti da malattie ematologiche rare. In particolare, il ricavato contribuirà al finanziamento di un progetto che l'Associazione ha deciso di supportare a favore dei pazienti affetti da <strong>Porpora Trombotica Trombocitopenica (PTT)</strong>.

<a href="/malattie-rare?malattia=porpora-trombotica-trombocitopenica" style="color: #E63129; text-decoration: underline; font-weight: 600;">Per approfondire il progetto, premi qui</a>`,
    color: "bg-red-600",
    images: [cenaPalestrina19Dic],
    videos: [],
    projectLink: "/malattie-rare?malattia=porpora-trombotica-trombocitopenica",
  },
  {
    id: 6,
    title: "Mercatino solidale – dicembre 2025",
    date: "16, 17 e 18 dicembre 2025",
    location: "Istituto Comprensivo di Via Anagni",
    description: `La scuola come luogo di solidarietà e partecipazione

Nei giorni 16, 17 e 18 dicembre 2025 si è svolto il mercatino solidale presso l'Istituto Comprensivo di Via Anagni, un'iniziativa di beneficenza <strong>ideata e organizzata dalla prof.ssa Antonella Citraro</strong> a favore dei pazienti affetti da malattie ematologiche rare seguiti presso il reparto di Ematologia dell'AOU Policlinico Umberto I di Roma.

L'evento ha rappresentato non solo un importante contributo concreto alle attività dell'Associazione Robin Hood Roma ODV, ma anche una significativa occasione educativa per gli alunni, che hanno potuto avvicinarsi a una realtà spesso poco conosciuta, comprendendo il valore della solidarietà, dell'inclusione e della responsabilità sociale.

Un sentito ringraziamento va alla <strong>prof.ssa Patricia Aiello</strong>, che si è resa disponibile ad assistere la prof.ssa Citraro, contribuendo alla buona riuscita dell'iniziativa, nonché agli alunni e alle loro famiglie, la cui partecipazione attiva ha reso possibile la raccolta complessiva di <strong>euro 560</strong>, destinata a sostenere i progetti dell'Associazione.

L'Associazione Robin Hood Roma ODV ringrazia la Dirigenza scolastica per il sostegno all'iniziativa e per l'attenzione costante ai valori della solidarietà e dell'inclusione, che rendono la scuola un luogo di crescita non solo culturale, ma anche civile e umana.`,
    color: "bg-teal-600",
    images: [mercatinoSolidale1, mercatinoSolidale2, mercatinoSolidale3, mercatinoSolidale4],
    videos: [],
  },
  {
    id: 11,
    title: "Il Futuro è Già nel Presente",
    date: "18 ottobre 2025",
    time: "10:30 - 17:30",
    location: "Albergo Etico, via Pisanelli 39, Roma",
    description: "Una giornata dedicata ai pazienti, con presentazione di progetti e raccolta fondi per l'acquisto dei reagenti per il monitoraggio dei pazienti con una malattia rara.",
    color: "bg-green-600",
    flyerImage: locandina18OttobreImg,
    externalLink: "/evento-18-ottobre",
    images: [
      foto18Ott1, foto18Ott2, foto18Ott3, foto18Ott4, foto18Ott5, foto18Ott6, foto18Ott7,
      foto18Ott8, foto18Ott9, foto18Ott10, foto18Ott11, foto18Ott12, foto18Ott13, foto18Ott14
    ]
  },
  {
    id: 3,
    title: "Evento Pugilistico a Sostegno dell'Associazione",
    date: "15 dicembre 2024",
    location: "Palestra Comunale “Roberto Stefoni” di Palombara Sabina",
    description: `15 dicembre 2024 - Palestra Comunale “Roberto Stefoni” di Palombara Sabina -Evento dell’Accademia Pugilistica Roma Est, in sostegno dell’Associazione Robin Hood Roma ODV

Domenica 15 dicembre 2024, l'Associazione Robin Hood Roma ODV è stata ospitata ad un evento pugilistico svoltosi nella Palestra Comunale “Roberto Stefoni” di Palombara Sabina, organizzato dall'Accademia Pugilistica Roma Est di Guidonia, diretta da Simone Autorino, e dalla Maximus Roma Est di Marcellina, coordinata da Veruska Sirimarco.
Tra gli atleti presenti alla manifestazione Luca D'Ortenzi, Campione Internazionale IBF dei Pesi Massimi Leggeri, in visita; Alessandro “Sandrino” Fersula, pugile professionista categoria 66 chilogrammi; l'argentino José Luis Comisso, esperto di sport da combattimento; Matteo Gubinelli, il 28enne pugile di Marcellina soprannominato “The Truck”. 
Pierluigi Girolami, socio e consigliere dell’Associazione Robin Hood Roma ODV, ha organizzato lo stand con i gadget dell’Associazione ed è stato presente, insieme ad altri volontari per tutta la durata della manifestazione, che ha interessato bambini, adolescenti e giovani adulti con un percorso di boxe alle spalle. I membri dell’Associazione hanno illustrato le attività dell’Associazione, suscitando interesse e sensibilità sia degli atleti che degli spettatori. 

Quello che è emerso è stata una condivisione di valori, sensibilità e amore verso il prossimo, che entrambi, sia lo Sport che il Volontariato, portano avanti. 
Molti pugili, dopo i combattimenti, hanno spontaneamente dato un contributo alla nostra Associazione.  

"Credo molto nel volontariato. E lo sosteniamo organizzando eventi come questi." continua il maestro di pugilato Autorini. "Perché abbiamo obiettivi comuni noi, come Accademia Pugilistica, e voi come Associazione di volontariato. Voi vorreste, come ho letto, ‘che nessun paziente abbia di meno’, a noi piacerebbe riuscire a togliere i ragazzi dalla strada, donando un’alternativa da ciò che effettivamente li circonda all’esterno, creando un vero e proprio punto di riferimento", afferma il maestro Simone Autorini. 

L'«Associazione Robin Hood Roma OVD» ringrazia la Proloco, gli atleti e le persone presenti all'evento, e Veruska Sirimarco, che ha organizzato l'evento.`,
    color: "bg-red-500",
    images: [],
    videos: [],
    flyerImage: pugilatoPalombaraImg,
  },
  {
    id: 4,
    title: "Evento Pugilistico a Sostegno dell'Associazione",
    date: "19 maggio 2024",
    location: "Palasport “Paolo Tosto” di Tivoli",
    description: `19 maggio 2024 - Palasport “Paolo Tosto” di Tivoli - Evento dell’Accademia Pugilistica Roma Est, in sostegno dell’Associazione Robin Hood Roma ODV


Il 19 maggio 2024 si è tenuta una competizione di pugilato presso il Palasport “Paolo Tosto” di Tivoli, organizzata dal Direttore Sportivo dell’Accademia Pugilistica Roma est, Sig.ra Sirimarco Veruska. Hanno partecipato a questo evento dilettanti e professionisti; in serata si è svolto l’incontro più atteso con il campione internazionale IBF, Luca D’Ortenzi.


Questa iniziativa ha attirato un numero considerevole di appassionati del mondo pugilistico che, con la loro attiva partecipazione, hanno
particolare l’evento. Tra i presenti, il Sindaco di Palombara Sabina, Alessandro Palombi.

L’iniziativa di sostegno all’Associazione Robin Hood Roma ODV è stata organizzata e sostenuta da Danila Gallotti, membro del Consiglio Direttivo dell’Associazione. 
Per dare maggiore visibilità alla mission dell’Associazione, prima dell’incontro più atteso la dott.ssa Gallotti ha illustrato quanto realizzato dall’Associazione nei confronti dei pazienti. 

E’ da sottolineare la sensibilità dei pugili, che hanno devoluto una parte del loro incasso, un gesto d’amore nei confronti del prossimo in difficoltà.


Alle organizzatrici, dott.ssa Gallotti e alla signora Sirimarco, agli atleti e agli allenatori, sono andati i ringraziamenti dell'Associazione.`,
    color: "bg-teal-500",
    images: [],
    videos: [],
    flyerImage: pugilatoSgurgolaImg,
  },
  {
    id: 5,
    title: "Social Football Summit 2023 - Charity Partner",
    date: "21-22 novembre 2023",
    location: "Roma",
    description: `Social Football Summit e l’Associazione Robin Hood Roma Onlus
L’Associazione Robin Hood Roma Onlus ha avuto l’onore di essere Charity Partner del
Social Football Summit che si è tenuto a Roma il 21 e 22 novembre 2023. Attraverso un’asta
di beneficenza, il Social Football Summit, sono stati raccolti più di 4.000€ che sono stati
devoluti all’ Associazione Robin Hood Roma Onlus, per acquistare i reagenti necessari
all’utilizzo di un analizzatore contaglobuli automatico che è stato installato nel Day Hospital del

1° piano malattie ematologiche rare pediatriche dell’Ematologia, AOU Policlinico Umberto I-
Università Sapienza, per ottimizzare l’assistenza dei pazienti, bambini ed adulti, con malattie

ematologiche rare.
L’analizzatore è uno strumento necessario perché calcola i livelli di emoglobina, il conteggio dei
globuli rossi, delle piastrine e dei globuli bianchi con la formula leucocitaria, con modalità tali da
avere i dati in tempo reale.
Per poter funzionare sono necessari reagenti particolari, che l’Associazione Robin Hood Roma
Onlus si è impegnata ad acquistare i reagenti necessari per circa 1500 prelievi/anno, per i
prossimi 4 anni.
Si ringrazia FIGC, Lega Serie A, Lega B e Lega Pro che si sono resi disponibili.
E tutte le persone che hanno fatto la loro offerta a sostegno della nostra iniziativa!`,
    color: "bg-indigo-500",
    images: [], // Placeholder per 4 foto
    videos: [], // Placeholder per video
  },
  {
    id: 1,
    title: "Secondo Incontro Associazione",
    date: "18 novembre 2023",
    location: "Albergo Etico",
    description: "Il 18 novembre 2023 si è svolto il secondo incontro dell'Associazione presso l' Albergo Etico, che ci ha, anche questa volta, entusiasticamente ospitato!\n\nÈ stata una giornata all'insegna della condivisone, della generosità e del buon umore.\nOltre ad un mercatino, reso prezioso dai quadri di Angelo Addessi e Gigliana Pelliccia, e dalle fotografie di Antonella Stelitano, è stato possibile assaporare momenti di relax in uno spazio dedicato .\n\nLa Presidente, dr.ssa Fiorina Giona, ha sottolineato l'importanza di un'alleanza che aiuti a costruire un percorso finalizzato non solo ad un'assistenza diagnostico-terapeutica adeguata, ma anche al benessere, non solo fisico, dei pazienti con malattie rare ematologiche e dei loro parenti.\nLa psicologa, dr.ssa Flora Gigli, prendendo spunto dal suo libro 'La cura del paziente oncoematologico', ha condiviso delle riflessioni sulle emozioni e sui bisogni che i pazienti si trovano ad affrontare nelle diverse fasi del percorso di cura.\nPaolo D'Isanto e Pascal La Delfa, meglio noti ai nostri pazienti come Dottor Ragù e Dottor Suppergiù, sono stati la sorpresa della giornata.\n\nNel pomeriggio, sono state proposte due forme di meditazione utili al rilassamento.\nLa Maestra Stefania Grappasonni ha proposto dolci esercizi per il corpo e la mente di Tai Chi Chuan e Qi Gong.\nL'Insegnante Linda Fidanzia ha condiviso un'esperienza di Mindfulness, utile a calmare la mente.\n\nA fine giornata, la Dr.ssa Loredana Battista ha regalato una ventata di leggerezza con l'angolo delle stelle.\nLa presenza numerosa e la partecipazione attiva di pazienti, dei loro parenti, e di amici ci ha scaldato il cuore e incoraggiato a proseguire nel nostro cammino.",
    color: "bg-accent",
    images: [],
    videos: [],
  },
  {
    id: 2,
    title: "Incontro per la Ripartenza dell'Associazione",
    date: "19 giugno 2023",
    time: "19:30 - 22:30",
    location: "Albergo Etico",
    description: "Il 19 di giugno si e' svolto un festoso incontro per la Ripartenza dell' Associazione presso l' Albergo Etico, che ci ha entusiasticamente ospitato! E' stata una serata emozionante con la presenza di molti pazienti (bambini e adulti), ex pazienti con figli e familiari.\n\nLa presenza di numerosi medici dell'Ematologia che da anni seguono questi pazienti ha contribuito a trasformare l'evento in una festa senza barriere e senza distinzione di ruoli, tra volontari, membri dell'Associazione, pazienti e medici.\nIl filo conduttore della serata e' stato il concetto di ripartenza!\n\nLa Presidente Dr.ssa Giona Fiorina ha rimarcato come sia importante per l'Associazione ripartire dopo il periodo del COVID con nuovo slancio e forza per fare sì che nessuno resti indietro quando si tratta di affrontare malattie rare ematologiche, di qualsiasi tipo! Emozionanti gli interventi di pazienti e familiari nel raccontare la loro sfida contro la malattia e il successivo ritorno alla vita normale!\n\nUn grazie al professore Maurizio Martelli, Direttore dell' Ematologia, per il suo saluto!",
    color: "bg-primary",
    images: [],
    videos: [],
    flyerImage: locandina19GiugnoImg,
  }
];

const upcomingEvents = [
  /* {
    id: 2,
    title: "Corso di Formazione per Volontarie e Volontari",
    date: "25 ottobre 2025",
    time: "09:00 - 12:30",
    location: "Ematologia - Via Benevento 27/A, Roma (IV piano sala riunioni)",
    description: "Un corso per offrire strumenti concreti e uno spazio di riflessione a chi vuole essere volontario: per imparare a essere utili con competenza, empatia e rispetto.",
    color: "bg-cyan-700",
    category: "Corso di Formazione",
    fullDescription: `CORSO DI FORMAZIONE per VOLONTARIE e VOLONTARI

Essere volontari non significa solo "dare una mano". Significa esserci davvero: ascoltare, accogliere, camminare accanto a chi sta affrontando un momento difficile.

Per questo nasce il nostro corso di formazione: per offrire a ogni volontario strumenti concreti, ma anche uno spazio di riflessione e crescita. Per imparare a essere utili con competenza, empatia e rispetto.

ESSERE VOLONTARIE e VOLONTARI in EMATOLOGIA

QUANDO E DOVE
Sabato 25 ottobre 2025, dalle 9:00 alle 12:30
EMATOLOGIA – Via Benevento 27/A, Roma (IV piano sala riunioni)

A CHI È RIVOLTO
• A chi è già volontario dell'associazione
• Sono benvenuti anche chi vuole avvicinarsi al volontariato perché crede che, anche nel piccolo, si possa fare qualcosa di grande

Cosa si imparerà:
• La struttura e l'organizzazione del posto dove si svolge l'attività di volontariato
• Le basi delle principali malattie ematologiche e dei percorsi di cura
• Il ruolo del volontario: cosa fare, cosa evitare, come relazionarsi
• L'importanza dell'ascolto attivo e del sostegno emotivo

Il volontariato è fatto di tempo, ascolto e presenza. Ma anche di preparazione, cura e rispetto.
Questo corso è il primo passo.

PROGRAMMA

Le volontarie e i volontari si presentano

Struttura e organizzazione dell'Ematologia: cosa deve sapere un/una volontario/a
(Dott.ssa Fiorina Giona)

Le patologie ematologiche spiegate al/alla volontario/a
(Dott.ssa Anna Maria Testi)

Emozioni in reparto: stare vicino con ascolto e sensibilità
(Dott.ssa Silvia Finocchi)`,
    flyerImage: locandinaCorsoVolontariImg,
    programLink: locandinaCorsoVolontariImg,
    downloadFileName: "Locandina_Corso_Formazione_Volontari_25_ottobre_2025.png"
  } */
  /* ,
  {
    id: 2, // ID univoco per i prossimi eventi
    category: "Evento Scientifico", // Categoria per distinguere
    title: "Approccio multidisciplinare nella Malattia di Gaucher e l'importanza della strategia terapeutica",
    date: "2 luglio 2025",
    time: "09:00 - 17:00",
    location: "Dipartimento di Scienze Odontostomatologiche e Maxillo Facciali - Via Caserta 6 – Roma",
    description: "Un evento scientifico dedicato all'approccio multidisciplinare nella Malattia di Gaucher e all'importanza della strategia terapeutica.",
    programLink: programmaGaucherPdf,
    color: "bg-sky-600", // Colore per gli eventi scientifici
    isScientific: true // Flag per differenziare
  } */
  // L'evento "Robin Hood Roma ODV nella giuria del Premio Strega 2026" è stato spostato
  // nella sezione EVENTI DELL'ASSOCIAZIONE ROBIN HOOD ROMA ODV (vedi pastEvents, id: 10).
  // Altri eventi futuri (dell'associazione o scientifici) potranno essere aggiunti qui
];

const Eventi = () => {
  const location = useLocation();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [calendar, setCalendar] = useState([]);
  const [lastFocusedElement, setLastFocusedElement] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [selectedPastEvent, setSelectedPastEvent] = useState(null);
  const [isPastEventModalOpen, setIsPastEventModalOpen] = useState(false);
  const [selectedUpcomingEvent, setSelectedUpcomingEvent] = useState(null);
  const [isUpcomingEventModalOpen, setIsUpcomingEventModalOpen] = useState(false);
  
  // Modali evento 7 marzo 2026
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isMediaModalOpen, setIsMediaModalOpen] = useState(false);
  const [isOrienteeringVideoModalOpen, setIsOrienteeringVideoModalOpen] = useState(false);

  // Modali Premio Strega 2026
  const [isVociLettoriModalOpen, setIsVociLettoriModalOpen] = useState(false);
  const [isStoriaLettoreModalOpen, setIsStoriaLettoreModalOpen] = useState(false);

  // Gallery states
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Refs for accessibility and focus management
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);
  const calendarCellsRef = useRef({});

  useEffect(() => {
    generateCalendarMonths();
  }, [currentDate]);

  // Check if we should open a specific event modal from navigation state
  useEffect(() => {
    if (location.state?.openUpcomingEventId) {
      const eventToOpen = upcomingEvents.find(event => event.id === location.state.openUpcomingEventId);
      if (eventToOpen) {
        openUpcomingEventModal(eventToOpen);
        // Clear the state to avoid reopening on subsequent renders
        window.history.replaceState({}, document.title);
      }
    }
  }, [location.state]);

  // Add tooltip position adjustment
  useEffect(() => {
    // Function to adjust tooltip positions
    const adjustTooltipPositions = () => {
      const tooltips = document.querySelectorAll('.tooltip-container');

      tooltips.forEach(tooltip => {
        // Get tooltip dimensions
        const rect = tooltip.getBoundingClientRect();
        const parentRect = tooltip.closest('.group').getBoundingClientRect();

        // Check if tooltip is going off-screen
        const isOffScreenRight = rect.right > window.innerWidth;
        const isOffScreenLeft = rect.left < 0;
        const isOffScreenTop = rect.top < 0;

        // Reset styles
        tooltip.style.bottom = '120%';
        tooltip.style.top = 'auto';
        tooltip.style.left = '50%';
        tooltip.style.transform = 'translateX(-50%)';

        // Adjust position if needed
        if (isOffScreenLeft) {
          tooltip.style.left = '0';
          tooltip.style.transform = 'translateX(0)';
        } else if (isOffScreenRight) {
          tooltip.style.left = 'auto';
          tooltip.style.right = '0';
          tooltip.style.transform = 'translateX(0)';
        }

        if (isOffScreenTop) {
          tooltip.style.bottom = 'auto';
          tooltip.style.top = '120%';

          // Move the arrow to the top
          const arrow = tooltip.querySelector('div > div:last-child');
          if (arrow) {
            arrow.classList.remove('top-full', 'border-t-gray-800');
            arrow.classList.add('bottom-full', 'border-b-gray-800');
          }
        }
      });
    };

    // Set up a mutation observer to detect when new tooltips appear
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('opacity-100')) {
          adjustTooltipPositions();
        }
      });
    });

    // Start observing changes
    const tooltipContainers = document.querySelectorAll('.tooltip-container');
    tooltipContainers.forEach(container => {
      observer.observe(container, { attributes: true });
    });

    // Also adjust on window resize
    window.addEventListener('resize', adjustTooltipPositions);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', adjustTooltipPositions);
    };
  }, [calendar]);

  // Scroll to top button visibility
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Generate calendar months for the entire year
  const generateCalendarMonths = () => {
    const months = [];
    const year = currentDate.getFullYear();

    for (let month = 0; month < 12; month++) {
      const firstDay = new Date(year, month, 1);
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      // Calculate days from previous month to fill first week
      const dayOfWeek = firstDay.getDay();
      const prevMonthDays = [];
      for (let i = 0; i < dayOfWeek; i++) {
        const day = new Date(year, month, -i);
        prevMonthDays.unshift(day);
      }

      // Current month days
      const monthDays = [];
      for (let day = 1; day <= daysInMonth; day++) {
        monthDays.push(new Date(year, month, day));
      }

      // Calculate days from next month to complete last week
      const totalDaysDisplayed = prevMonthDays.length + monthDays.length;
      const nextMonthDays = [];
      for (let i = 1; i <= (42 - totalDaysDisplayed); i++) {
        nextMonthDays.push(new Date(year, month + 1, i));
      }

      months.push({
        name: monthNames[month],
        days: [...prevMonthDays, ...monthDays, ...nextMonthDays]
      });
    }

    setCalendar(months);
  };

  // Check if a specific date has events
  const getEventsForDate = (date) => {
    return awarenessEvents.filter((event) => {
      if (event.type === 'day') {
        return date.getDate() === event.date.getDate() &&
          date.getMonth() === event.date.getMonth();
      } else if (event.type === 'week') {
        // For week events
        const eventStartTime = event.date.getTime();
        const eventEndTime = event.endDate.getTime();
        const dateTime = date.getTime();
        return dateTime >= eventStartTime && dateTime <= eventEndTime;
      }
      return false;
    });
  };

  // Open modal with event details
  const openEventModal = (event, sourceElement = null) => {
    if (sourceElement) {
      setLastFocusedElement(sourceElement);
    }
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  // Open modal with past event details
  const openPastEventModal = (event, sourceElement = null) => {
    if (sourceElement) {
      setLastFocusedElement(sourceElement);
    }
    setSelectedPastEvent(event);
    setIsPastEventModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedEvent(null), 300);

    // Return focus to the element that opened the modal
    if (lastFocusedElement) {
      setTimeout(() => {
        lastFocusedElement.focus();
      }, 50);
    }
  };

  // Close past event modal
  const closePastEventModal = () => {
    setIsPastEventModalOpen(false);
    setTimeout(() => setSelectedPastEvent(null), 300);

    // Return focus to the element that opened the modal
    if (lastFocusedElement) {
      setTimeout(() => {
        lastFocusedElement.focus();
      }, 50);
    }
  };

  // Open modal with upcoming event details
  const openUpcomingEventModal = (event, sourceElement = null) => {
    if (sourceElement) {
      setLastFocusedElement(sourceElement);
    }
    setSelectedUpcomingEvent(event);
    setIsUpcomingEventModalOpen(true);
  };

  // Close upcoming event modal
  const closeUpcomingEventModal = () => {
    setIsUpcomingEventModalOpen(false);
    setTimeout(() => setSelectedUpcomingEvent(null), 300);

    // Return focus to the element that opened the modal
    if (lastFocusedElement) {
      setTimeout(() => {
        lastFocusedElement.focus();
      }, 50);
    }
  };

  // Handle keyboard interactions for the modal
  const handleModalKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  };

  // Handle keyboard interactions for the past event modal
  const handlePastEventModalKeyDown = (e) => {
    if (e.key === 'Escape') {
      closePastEventModal();
    }
  };

  // Handle keyboard interactions for the upcoming event modal
  const handleUpcomingEventModalKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeUpcomingEventModal();
    }
  };

  // Gallery functions
  const openGallery = (images, startIndex = 0) => {
    setGalleryImages(images);
    setCurrentImageIndex(startIndex);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setTimeout(() => {
      setGalleryImages([]);
      setCurrentImageIndex(0);
    }, 300);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const handleGalleryKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeGallery();
    } else if (e.key === 'ArrowRight') {
      nextImage();
    } else if (e.key === 'ArrowLeft') {
      prevImage();
    }
  };

  // Focus trapping for the modal
  useEffect(() => {
    if (isModalOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isModalOpen]);

  // Focus trapping for the past event modal
  useEffect(() => {
    if (isPastEventModalOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isPastEventModalOpen]);

  // Focus trapping for the upcoming event modal
  useEffect(() => {
    if (isUpcomingEventModalOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isUpcomingEventModalOpen]);

  // Handle keyboard navigation for calendar cells
  const handleCalendarKeyDown = useCallback((e, day, monthIndex, dayIndex, events) => {
    // Handle Enter or Space to open modal
    if ((e.key === 'Enter' || e.key === ' ') && events.length > 0) {
      e.preventDefault();
      openEventModal(events[0], e.target);
      return;
    }

    // Arrow key navigation
    const handleArrowNavigation = (nextMonthIndex, nextDayIndex) => {
      e.preventDefault();
      const nextCell = calendarCellsRef.current[`${nextMonthIndex}-${nextDayIndex}`];
      if (nextCell) {
        nextCell.focus();
      }
    };

    switch (e.key) {
      case 'ArrowRight':
        handleArrowNavigation(monthIndex, dayIndex + 1);
        break;
      case 'ArrowLeft':
        handleArrowNavigation(monthIndex, dayIndex - 1);
        break;
      case 'ArrowUp':
        handleArrowNavigation(monthIndex, dayIndex - 7);
        break;
      case 'ArrowDown':
        handleArrowNavigation(monthIndex, dayIndex + 7);
        break;
      default:
        break;
    }
  }, [openEventModal]);

  // Format date for display
  const formatDate = (date) => {
    return `${date.getDate()} ${monthNames[date.getMonth()]}`;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary/80">
        <div className="container mx-auto px-4 py-16 md:py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Eventi</h1>
            <p className="text-xl text-white md:w-3/4 mx-auto">
              Scopri e partecipa agli eventi dell'Associazione Robin Hood Roma ODV, per dare anche il tuo supporto!
              <br />Scopri gli eventi scientifici sulle malattie rare!
              <br />Scopri le giornate mondiali dedicate alla sensibilizzazione sulle malattie rare e non!
            </p>
          </div>
        </div>
      </div>

      {/* SEZIONE "PROSSIMI EVENTI" DISATTIVATA (luglio 2026).
          L'unico evento presente (Premio Strega 2026) è stato spostato nella sezione
          EVENTI DELL'ASSOCIAZIONE ROBIN HOOD ROMA ODV (pastEvents, id: 10).
          Per riattivarla: rimuovere l'apertura di commento qui sotto e la chiusura
          corrispondente in fondo al blocco, poi ripopolare l'array upcomingEvents. */}
      {/*
      <div className="container mx-auto px-4 py-8">
        <div className="bg-gradient-to-b from-white to-primary/5 rounded-lg shadow-md p-6 mb-8 border border-primary/10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 mr-2 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            PROSSIMI EVENTI
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            {upcomingEvents.length > 0 ? (
              upcomingEvents.map((event) => (
                <div
                  key={event.id}
                  className="bg-white rounded-lg shadow-md overflow-hidden border border-primary/10 hover:shadow-lg transition-all duration-300 transform hover:scale-102 flex flex-col"
                >
                  <div className={`${event.color} text-white p-4`}>
                    {event.category && (
                      <span className="text-xs font-semibold bg-white/20 text-white px-2 py-1 rounded-full mb-2 inline-block">{event.category}</span>
                    )}
                    <h3 className="text-xl font-bold">{event.title}</h3>
                    <p className="text-sm mt-2 opacity-90 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      {event.date}
                    </p>
                    {event.time && event.time.trim().toUpperCase() !== "DA DEFINIRE" && event.time.trim() !== "" && (
                      <p className="text-sm mt-1 opacity-90 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        {event.time}
                      </p>
                    )}
                    <p className="text-sm mt-1 opacity-90 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      {event.location}
                    </p>
                    {event.website && (
                      <a
                        href={event.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm mt-1 opacity-90 flex items-center hover:opacity-100 transition-opacity"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                        {event.website.replace('https://', '').replace('http://', '').replace(/\/$/, '')}
                      </a>
                    )}
                  </div>
                  <div className="p-4 flex flex-row gap-4 items-start flex-grow min-h-[180px]">
                    <div className="flex-grow flex flex-col min-h-full">
                      <p className="text-sm text-gray-700 mb-4 flex-grow whitespace-pre-line">{event.description}</p>
                      <div className="flex gap-3 justify-start flex-wrap">
                        {event.fullDescription && (
                          <button
                            className="inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-300"
                            onClick={(e) => {
                              e.preventDefault();
                              openUpcomingEventModal(event, e.currentTarget);
                            }}
                          >
                            Leggi tutto
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </button>
                        )}
                        {event.programLink && (
                          <a
                            href={event.programLink}
                            download={event.downloadFileName || "Programma_Evento.pdf"}
                            className="inline-flex items-center px-4 py-2 bg-accent text-white text-sm font-medium rounded-md hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent transition-colors duration-300"
                            aria-label={`Scarica ${event.downloadFileName ? 'la locandina' : 'il programma'} per ${event.title}`}
                          >
                            {event.downloadFileName ? 'Scarica Locandina' : 'Scarica Programma'}
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                          </a>
                        )}
                      </div>
                    </div>
                    {event.videos && event.videos.length > 0 ? (
                      <div className="w-1/3 flex-shrink-0 self-center">
                        <video
                          src={event.videos[0]}
                          muted
                          loop
                          autoPlay
                          playsInline
                          className="w-full h-auto object-contain rounded-md shadow-sm"
                          style={{ maxHeight: '130px' }}
                        />
                      </div>
                    ) : event.flyerImage && (
                      <div className="w-1/3 flex-shrink-0 self-center">
                        <img
                          src={event.flyerImage}
                          alt={`Locandina ${event.title}`}
                          className="w-full h-auto object-contain rounded-md shadow-sm"
                          style={{ maxHeight: '130px' }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p className="text-gray-600 italic col-span-full text-center">Nella prima metà di giugno è previsto un evento per il lancio della Sezione Young. <br /> Torna a trovarci presto per conoscere la data e il programma!</p>
            )}
          </div>
        </div>
      </div>
      */}

      {/* EVENTI DELL'ASSOCIAZIONE ROBIN HOOD ROMA ODV Section (Ex Eventi Passati) */}
      <div className="container mx-auto px-4 py-8">
        <div className="bg-gradient-to-b from-white to-accent/5 rounded-lg shadow-md p-6 mb-8 border border-accent/10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 mr-2 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            EVENTI DELL'ASSOCIAZIONE ROBIN HOOD ROMA ODV
          </h2>
          {/* Contenuto degli eventi passati dell'associazione va qui */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            {pastEvents.map((event) => (
              <div
                key={event.id}
                className="bg-white rounded-lg shadow-md overflow-hidden border border-accent/10 hover:shadow-lg transition-all duration-300 transform hover:scale-102 flex flex-col"
              >
                <div className={`${event.color} text-white p-4`}>
                  <h3 className="text-xl font-bold">{event.title}</h3>
                  <p className="text-sm mt-2 opacity-90 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    {event.date}
                  </p>
                  {event.time && event.time.trim().toUpperCase() !== "DA DEFINIRE" && event.time.trim() !== "" && (
                    <p className="text-sm mt-1 opacity-90 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {event.time}
                    </p>
                  )}
                  <p className="text-sm mt-1 opacity-90 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    {event.location}
                  </p>
                  {event.website && (
                    <a
                      href={event.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm mt-1 opacity-90 flex items-center hover:opacity-100 transition-opacity"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                      </svg>
                      {event.website.replace('https://', '').replace('http://', '').replace(/\/$/, '')}
                    </a>
                  )}
                </div>
                <div className="p-4 flex flex-row gap-4 items-start flex-grow min-h-[180px]"> {/* Aggiunto flex flex-row gap-4 items-start flex-grow e min-height */}
                  <div className="flex-grow flex flex-col min-h-full"> {/* Contenitore per testo e pulsante, che permette al pulsante di stare in fondo */}
                    <div className="text-sm text-gray-700 mb-4 line-clamp-3 flex-grow"> {/* flex-grow qui per spingere il pulsante se il testo è corto */}
                      {event.description.split('\n')[0]}
                    </div>
                    <div className="flex flex-col gap-2">
                      <div className="flex gap-3 flex-wrap">
                        {event.externalLink ? (
                          <Link
                            to={event.externalLink}
                            className="inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-300"
                          >
                            Leggi tutto
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </Link>
                        ) : (
                          <button
                            className="inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-300"
                            onClick={(e) => {
                              e.preventDefault();
                              openPastEventModal(event, e.currentTarget);
                            }}
                          >
                            Leggi tutto
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                          </button>
                        )}
                        {/* id 10 (Premio Strega): il flyer è il logo del Premio, non una locandina scaricabile */}
                        {(event.programLink || (event.flyerImage && event.id !== 10)) && (
                          <a
                            href={event.programLink || event.flyerImage}
                            download={event.programLink ? (event.downloadFileName || "Locandina.pdf") : `Locandina_${event.title.replace(/\s+/g, '_')}.png`}
                            className="inline-flex items-center px-4 py-2 bg-accent text-white text-sm font-medium rounded-md hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent transition-colors duration-300"
                            aria-label={`Scarica la locandina per ${event.title}`}
                          >
                            Scarica Locandina
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                          </a>
                        )}
                        {event.images && event.images.length > 0 && event.id !== 8 && (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              openGallery(event.images);
                            }}
                            className="inline-flex items-center px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-600 transition-colors duration-300"
                            aria-label={`Visualizza galleria foto per ${event.title}`}
                          >
                            Galleria foto
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                          </button>
                        )}
                        {event.id === 10 && (
                          <>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                setIsVociLettoriModalOpen(true);
                              }}
                              className="inline-flex items-center px-4 py-2 bg-emerald-700 text-white text-sm font-medium rounded-md hover:bg-emerald-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-700 transition-colors duration-300"
                              aria-label={`Leggi le voci dei lettori per ${event.title}`}
                            >
                              Voci dei lettori
                              <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                              </svg>
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                setIsStoriaLettoreModalOpen(true);
                              }}
                              className="inline-flex items-center px-4 py-2 bg-green-700 text-white text-sm font-medium rounded-md hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-700 transition-colors duration-300"
                              aria-label={`Leggi "La mia storia di lettore" per ${event.title}`}
                            >
                              La mia storia di lettore
                              <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                              </svg>
                            </button>
                          </>
                        )}
                      </div>
                      {event.id === 8 && (
                        <div className="flex gap-3 flex-wrap">
                          <button
                            onClick={() => setIsVideoModalOpen(true)}
                            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 transition-colors duration-300"
                          >
                            Video dell'incontro
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                              <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => openGallery(event.images)}
                            className="inline-flex items-center px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-600 transition-colors duration-300"
                          >
                            Galleria foto
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => setIsMediaModalOpen(true)}
                            className="inline-flex items-center px-4 py-2 bg-teal-600 text-white text-sm font-medium rounded-md hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-600 transition-colors duration-300"
                          >
                            Hanno parlato di noi
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                            </svg>
                          </button>
                        </div>
                      )}
                      {event.id === 9 && (
                        <div className="flex gap-3 flex-wrap">
                          <button
                            onClick={() => setIsOrienteeringVideoModalOpen(true)}
                            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 transition-colors duration-300"
                          >
                            Video dell'incontro
                            <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                              <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  {event.videos && event.videos.length > 0 ? (
                    <div className="w-1/3 flex-shrink-0 self-center">
                      <video
                        src={event.videos[0]}
                        muted
                        loop
                        autoPlay
                        playsInline
                        controls
                        className="w-full h-auto object-contain rounded-md shadow-sm"
                        style={{ maxHeight: '130px' }}
                      />
                    </div>
                  ) : event.flyerImage && (
                    <div className="w-1/3 flex-shrink-0 self-center">
                      <img
                        src={event.flyerImage}
                        alt={`Locandina ${event.title}`}
                        className="w-full h-auto object-contain rounded-md shadow-sm"
                        style={{ maxHeight: '130px' }}
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* GIORNATE MONDIALI SULLE MALATTIE RARE E NON Section (Calendar Section) */}
      <div className="container mx-auto px-4 py-8">
        <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg shadow-md p-6 mb-8 border border-primary/10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
            {/* Icona opzionale per il titolo principale */}
            GIORNATE MONDIALI SULLE MALATTIE RARE E NON
          </h2>
          <h2 className="text-xl font-semibold text-gray-700 mb-4 flex items-center mt-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            Calendario Annuale
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Questo calendario presenta tutte le giornate mondiali dedicate alla sensibilizzazione sulle malattie rare.
            Queste ricorrenze si ripetono ogni anno alle stesse date e sono un'occasione importante per informare,
            sensibilizzare e sostenere i pazienti, le famiglie e gli operatori sanitari coinvolti.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {calendar.map((month, monthIndex) => (
            <div
              key={month.name}
              className="bg-white rounded-lg shadow-md overflow-hidden transform transition-all duration-500 hover:shadow-lg animate-fadeIn"
              id={`month-${monthIndex}`}
              style={{ animationDelay: `${monthIndex * 100}ms` }}
            >
              <div className="bg-gradient-to-r from-primary to-primary
 text-white px-4 py-3">
                <h3 className="text-xl font-semibold">{month.name}</h3>
              </div>
              <div className="p-4">
                {/* Days of week headers */}
                <div className="grid grid-cols-7 gap-1 mb-2">
                  {dayNames.map(day => (
                    <div key={day} className="text-center text-sm font-medium text-gray-500" role="columnheader" aria-label={day}>
                      {day}
                    </div>
                  ))}
                </div>

                {/* Calendar days */}
                <div className="grid grid-cols-7 gap-1" role="grid" aria-label={`Calendario di ${month.name}`}>
                  {month.days.map((day, index) => {
                    const isCurrentMonth = day.getMonth() === monthIndex;
                    const events = getEventsForDate(day);
                    const hasEvents = events.length > 0;

                    return (
                      <div
                        key={index}
                        ref={el => calendarCellsRef.current[`${monthIndex}-${index}`] = el}
                        className={`
                            p-2 min-h-[40px] text-center rounded-md 
                            ${isCurrentMonth ? 'text-gray-800' : 'text-gray-400'} 
                            ${hasEvents ? 'cursor-pointer relative shadow-sm focus:ring-2 focus:ring-primary focus:outline-none' : ''}\
                            ${hasEvents ? 'before:absolute before:inset-0 before:rounded-md before:bg-gray-100 before:opacity-0 hover:before:opacity-90 before:transition-opacity before:duration-300 before:ease-in-out' : ''}
                            ${hasEvents ? 'after:absolute after:inset-0 after:rounded-md after:shadow-md after:opacity-0 hover:after:opacity-100 after:transition-opacity after:duration-300 after:ease-in-out' : ''}
                            ${hasEvents ? 'hover:scale-105 transform transition-transform duration-300 ease-in-out' : ''}
                            relative
                          `}
                        role="gridcell"
                        aria-label={`${day.getDate()} ${monthNames[day.getMonth()]}, ${hasEvents ? events.length + ' eventi' : 'nessun evento'}`}
                        tabIndex={hasEvents ? 0 : -1}
                        onClick={(e) => {
                          if (hasEvents && events.length === 1) {
                            openEventModal(events[0], e.currentTarget);
                          } else if (hasEvents && events.length > 1) {
                            // If multiple events, show first one
                            openEventModal(events[0], e.currentTarget);
                          }
                        }}
                        onKeyDown={(e) => hasEvents && handleCalendarKeyDown(e, day, monthIndex, index, events)}
                      >
                        <span className="text-sm">{day.getDate()}</span>

                        {/* Event indicators */}
                        {hasEvents && (
                          <div className="mt-1 flex flex-wrap justify-center gap-1">
                            {events.map((event, eventIndex) => (
                              <span
                                key={eventIndex}
                                className={`${event.color} w-2 h-2 rounded-full inline-block transform transition-all duration-300 hover:scale-150`}
                                aria-hidden="true"
                              />
                            ))}
                          </div>
                        )}

                        {/* Tooltip for hover */}
                        {hasEvents && (
                          <div className="absolute inset-0 rounded-md group">
                            <div
                              className="tooltip-container opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-all duration-300 transform group-hover:translate-y-0 translate-y-1 absolute z-50"
                              style={{
                                bottom: '120%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                maxWidth: '250px',
                                width: 'max-content'
                              }}
                            >
                              <div className="px-3 py-2 bg-gray-800 text-white text-xs rounded-md shadow-lg backdrop-blur">
                                <div className="px-3 py-2 bg-gray-800 text-white text-xs rounded-md shadow-lg">
                                  {events.map((event, eventIndex) => (
                                    <div key={eventIndex} className="whitespace-normal break-words">
                                      {event.title}
                                      {eventIndex < events.length - 1 && <hr className="my-1 border-gray-600" />}
                                    </div>
                                  ))}
                                </div>
                                <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>



        {/* Event Detail Modal */}
        {isModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn"
            onClick={(e) => e.target === e.currentTarget && closeModal()}
            onKeyDown={handleModalKeyDown}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            ref={modalRef}
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden animate-scaleIn border border-gray-200"
              onClick={(e) => e.stopPropagation()}
            >
              {selectedEvent && (
                <>
                  <div className={`${selectedEvent.color} px-6 py-5 text-white relative`}>
                    <button
                      ref={closeButtonRef}
                      onClick={closeModal}
                      className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                      aria-label="Chiudi modal"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <h3 className="text-2xl font-bold" id="modal-title">{selectedEvent.title}</h3>
                    <div className="flex items-center mt-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <p className="text-sm opacity-90">
                        {selectedEvent.type === 'day'
                          ? formatDate(selectedEvent.date)
                          : `${formatDate(selectedEvent.date)} - ${formatDate(selectedEvent.endDate)}`
                        }
                      </p>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="bg-gray-50 p-4 rounded-lg mb-6 border-l-4 border-gray-300">
                      <p className="text-gray-700 leading-relaxed">
                        {selectedEvent.description}
                      </p>
                    </div>
                    <div className="border-t pt-4 mt-4 flex justify-end">
                      <button
                        onClick={closeModal}
                        className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                        aria-label="Chiudi modal"
                      >
                        Chiudi
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Past Event Detail Modal */}
        {isPastEventModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && closePastEventModal()}
            onKeyDown={handlePastEventModalKeyDown}
            role="dialog"
            aria-modal="true"
            aria-labelledby="past-modal-title"
            ref={modalRef}
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              {selectedPastEvent && (
                <>
                  <div className={`${selectedPastEvent.color} px-6 py-5 text-white relative sticky top-0 z-10`}>
                    <button
                      ref={closeButtonRef}
                      onClick={closePastEventModal}
                      className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                      aria-label="Chiudi modal"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <h3 className="text-2xl font-bold" id="past-modal-title">{selectedPastEvent.title}</h3>
                    <div className="flex items-center mt-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedPastEvent.date}</p>
                    </div>
                    {/* <div className="flex items-center mt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedPastEvent.time}</p>
                    </div> */}
                    <div className="flex items-center mt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedPastEvent.location}</p>
                    </div>
                    {selectedPastEvent.website && (
                      <a
                        href={selectedPastEvent.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center mt-1 text-sm opacity-90 hover:opacity-100 transition-opacity"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                        <p className="text-sm opacity-90">{selectedPastEvent.website.replace('https://', '').replace('http://', '').replace(/\/$/, '')}</p>
                      </a>
                    )}
                  </div>
                  <div className="p-6 pb-16 max-h-[70vh] overflow-y-auto">
                    {selectedPastEvent.videos && selectedPastEvent.videos.length > 0 ? (
                      <div className="mb-6">
                        <video
                          src={selectedPastEvent.videos[0]}
                          controls
                          className="w-full max-w-lg mx-auto rounded-lg shadow-lg"
                        />
                      </div>
                    ) : (selectedPastEvent.modalImage || selectedPastEvent.flyerImage) && (
                      <div className="mb-6">
                        <img
                          src={selectedPastEvent.modalImage || selectedPastEvent.flyerImage}
                          alt={`Locandina ${selectedPastEvent.title}`}
                          className="w-full max-w-lg mx-auto rounded-lg shadow-lg object-contain"
                          style={{ maxHeight: '50vh' }}
                        />
                      </div>
                    )}
                    <div className="bg-gray-50 p-5 rounded-lg mb-6 border-l-4 border-gray-300">
                      {/*                       <h4 className="font-semibold text-gray-800 mb-3">Info</h4>
 */}                      <div
                        className="text-gray-700 leading-relaxed whitespace-pre-line text-base"
                        dangerouslySetInnerHTML={{ __html: selectedPastEvent.fullDescription || selectedPastEvent.description }}
                      />
                    </div>
                    {selectedPastEvent.images && selectedPastEvent.images.length > 0 && (
                      <div className="mt-4">
                        <button
                          onClick={() => openGallery(selectedPastEvent.images)}
                          className="w-full inline-flex items-center justify-center px-6 py-3 bg-purple-600 text-white font-medium rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-600 transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          Galleria foto ({selectedPastEvent.images.length} {selectedPastEvent.images.length === 1 ? 'foto' : 'foto'})
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="p-3 flex justify-end gap-3 shadow-lg border-t border-gray-200 sticky bottom-0 z-10 bg-white">
                    {/* id 10 (Premio Strega): il flyer è il logo del Premio, non una locandina scaricabile */}
                    {(selectedPastEvent.programLink || (selectedPastEvent.flyerImage && selectedPastEvent.id !== 10)) && (
                      <a
                        href={selectedPastEvent.programLink || selectedPastEvent.flyerImage}
                        download={selectedPastEvent.programLink ? (selectedPastEvent.downloadFileName || "Locandina.pdf") : `Locandina_${selectedPastEvent.title.replace(/\s+/g, '_')}.png`}
                        className="inline-flex items-center px-5 py-2 bg-accent text-white rounded-md hover:bg-accent/90 transition-colors focus:outline-none focus:ring-2 focus:ring-accent shadow-sm"
                        aria-label={`Scarica la locandina per ${selectedPastEvent.title}`}
                      >
                        Scarica Locandina
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                      </a>
                    )}
                    {selectedPastEvent.images && selectedPastEvent.images.length > 0 && (
                      <button
                        onClick={() => openGallery(selectedPastEvent.images)}
                        className="inline-flex items-center px-5 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors focus:outline-none focus:ring-2 focus:ring-purple-600 shadow-sm"
                        aria-label="Visualizza galleria foto"
                      >
                        Galleria foto
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </button>
                    )}
                    <button
                      onClick={closePastEventModal}
                      className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                      aria-label="Chiudi modal"
                    >
                      Chiudi
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Upcoming Event Detail Modal */}
        {isUpcomingEventModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && closeUpcomingEventModal()}
            onKeyDown={handleUpcomingEventModalKeyDown}
            role="dialog"
            aria-modal="true"
            aria-labelledby="upcoming-modal-title"
            ref={modalRef}
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col max-h-[90vh]"
              onClick={(e) => e.stopPropagation()}
            >
              {selectedUpcomingEvent && (
                <>
                  <div className={`${selectedUpcomingEvent.color} px-6 py-5 text-white relative sticky top-0 z-10`}>
                    <button
                      ref={closeButtonRef}
                      onClick={closeUpcomingEventModal}
                      className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                      aria-label="Chiudi modal"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <h3 className="text-2xl font-bold" id="upcoming-modal-title">{selectedUpcomingEvent.title}</h3>
                    <div className="flex items-center mt-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedUpcomingEvent.date}</p>
                    </div>
                    {selectedUpcomingEvent.time && selectedUpcomingEvent.time.trim().toUpperCase() !== "DA DEFINIRE" && selectedUpcomingEvent.time.trim() !== "" && (
                      <div className="flex items-center mt-1">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-sm opacity-90">{selectedUpcomingEvent.time}</p>
                      </div>
                    )}
                    <div className="flex items-center mt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedUpcomingEvent.location}</p>
                    </div>
                    {selectedUpcomingEvent.website && (
                      <a
                        href={selectedUpcomingEvent.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center mt-1 text-sm opacity-90 hover:opacity-100 transition-opacity"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                        </svg>
                        <p className="text-sm opacity-90">{selectedUpcomingEvent.website.replace('https://', '').replace('http://', '').replace(/\/$/, '')}</p>
                      </a>
                    )}
                  </div>
                  <div className="p-6 pb-16 overflow-y-auto flex-grow">
                    {(selectedUpcomingEvent.modalImage || selectedUpcomingEvent.flyerImage) && (
                      <div className="mb-6">
                        <img
                          src={selectedUpcomingEvent.modalImage || selectedUpcomingEvent.flyerImage}
                          alt={`Locandina ${selectedUpcomingEvent.title}`}
                          className="w-full max-w-lg mx-auto rounded-lg shadow-lg object-contain"
                          style={{ maxHeight: '50vh' }}
                        />
                      </div>
                    )}
                    <div className="bg-gray-50 p-5 rounded-lg mb-6 border-l-4 border-gray-300">
                      {selectedUpcomingEvent.fullDescription && selectedUpcomingEvent.fullDescription.includes('<') ? (
                        <div
                          className="text-gray-700 leading-relaxed text-base prose prose-sm max-w-none"
                          dangerouslySetInnerHTML={{ __html: selectedUpcomingEvent.fullDescription }}
                        />
                      ) : (
                        <div className="text-gray-700 leading-relaxed whitespace-pre-line text-base">
                          {selectedUpcomingEvent.fullDescription || selectedUpcomingEvent.description}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="p-3 flex justify-end gap-3 shadow-lg border-t border-gray-200 sticky bottom-0 z-10 bg-white">
                    {selectedUpcomingEvent.programLink && (
                      <a
                        href={selectedUpcomingEvent.programLink}
                        download={selectedUpcomingEvent.downloadFileName || "Programma_Evento.pdf"}
                        className="inline-flex items-center px-5 py-2 bg-accent text-white rounded-md hover:bg-accent/90 transition-colors focus:outline-none focus:ring-2 focus:ring-accent shadow-sm"
                        aria-label={`Scarica ${selectedUpcomingEvent.downloadFileName ? 'la locandina' : 'il programma'} per ${selectedUpcomingEvent.title}`}
                      >
                        {selectedUpcomingEvent.downloadFileName ? 'Scarica Locandina' : 'Scarica Programma'}
                        <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                        </svg>
                      </a>
                    )}
                    <button
                      onClick={closeUpcomingEventModal}
                      className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                      aria-label="Chiudi modal"
                    >
                      Chiudi
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Modale Video dell'incontro - 7 marzo 2026 */}
        {isVideoModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && setIsVideoModalOpen(false)}
            role="dialog"
            aria-modal="true"
            aria-labelledby="video-modal-title"
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col max-h-[90vh]"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="bg-blue-600 px-6 py-5 text-white relative">
                <button
                  onClick={() => setIsVideoModalOpen(false)}
                  className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                  aria-label="Chiudi modal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
                <h3 className="text-2xl font-bold" id="video-modal-title">Video dell'incontro</h3>
                <p className="text-sm opacity-90 mt-1">La malattia non è tutta la storia… – 7 marzo 2026</p>
              </div>
              <div className="p-6 overflow-y-auto">
                <p className="text-gray-700 leading-relaxed mb-6">
                  Benvenuti a rivivere questa giornata speciale, ricca di emozioni e partecipazione.
                </p>
                <div className="flex flex-col gap-4">
                  <a
                    href="https://youtube.com/watch?v=DnKflQEqcy8&feature=shared"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors duration-200 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                      </svg>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 group-hover:text-blue-700">Prima parte</p>
                      <p className="text-sm text-gray-500">Guarda su YouTube</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-auto h-5 w-5 text-gray-400 group-hover:text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                  <a
                    href="https://youtu.be/8WMJeSiVTJE?si=zQ509exVfWJyh_cw"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-300 transition-colors duration-200 group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                      </svg>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 group-hover:text-blue-700">Seconda parte</p>
                      <p className="text-sm text-gray-500">Guarda su YouTube</p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-auto h-5 w-5 text-gray-400 group-hover:text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="p-3 flex justify-end border-t border-gray-200 bg-white">
                <button
                  onClick={() => setIsVideoModalOpen(false)}
                  className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modale Video dell'incontro - OrientiAMOci Insieme! 6 giugno 2026 */}
        {isOrienteeringVideoModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && setIsOrienteeringVideoModalOpen(false)}
            role="dialog"
            aria-modal="true"
            aria-labelledby="orienteering-video-modal-title"
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col max-h-[90vh]"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="bg-blue-600 px-6 py-5 text-white relative">
                <button
                  onClick={() => setIsOrienteeringVideoModalOpen(false)}
                  className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                  aria-label="Chiudi modal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
                <h3 className="text-2xl font-bold" id="orienteering-video-modal-title">Video dell'incontro</h3>
                <p className="text-sm opacity-90 mt-1">OrientiAMOci Insieme! – 6 giugno 2026</p>
              </div>
              <div className="p-6 overflow-y-auto">
                <video
                  src={videoOrienteering}
                  controls
                  playsInline
                  className="w-full h-auto max-h-[70vh] rounded-lg shadow-lg bg-black"
                />
              </div>
              <div className="p-3 flex justify-end border-t border-gray-200 bg-white">
                <button
                  onClick={() => setIsOrienteeringVideoModalOpen(false)}
                  className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modale Hanno parlato di noi - 7 marzo 2026 */}
        {isMediaModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && setIsMediaModalOpen(false)}
            role="dialog"
            aria-modal="true"
            aria-labelledby="media-modal-title"
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col max-h-[90vh]"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="bg-teal-600 px-6 py-5 text-white relative">
                <button
                  onClick={() => setIsMediaModalOpen(false)}
                  className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                  aria-label="Chiudi modal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
                <h3 className="text-2xl font-bold" id="media-modal-title">Hanno parlato di noi</h3>
                <p className="text-sm opacity-90 mt-1">La malattia non è tutta la storia… – 7 marzo 2026</p>
              </div>
              <div className="p-6 overflow-y-auto">
                <div className="flex flex-col gap-4 text-gray-700 leading-relaxed">
                  <p>
                    Questo evento ha avuto una risonanza particolare. L'Associazione esprime gratitudine per tutti quelli che hanno aderito all'iniziativa.
                  </p>
                  <p>
                    Un grazie speciale alla giornalista Paola Zanoni, direttrice di Academy of Art and Image, che ha dato un valore aggiunto all'incontro.
                  </p>
                  <p>
                    Un encomio particolare alla <a href="https://www.frameacademy360.com/" target="_blank" rel="noopener noreferrer" className="text-teal-700 underline font-semibold hover:text-teal-900">Frame Academy 360</a> che ha seguito l'intero evento con le telecamere, grazie all'impegno di un ragazzo, Nicholas Di Filippo, ex paziente dell'Ematologia Pediatrica, che ha voluto realizzare insieme ai fratelli Mattias e Nicolò foto e video per la distribuzione di servizi a media e tv regionali. Hanno generosamente aderito all'iniziativa della diffusione dell'evento l'editore Franco Lattanzi su TeleRoma2 canale 83 del Lazio e streaming tv nazionale per la versione integrale, il gruppo Gold tv e Lazio Tv del Pres. Gianfranco Sciscione, il regista Giuseppe Morelli e la giornalista Irene Taurino, il giornalista Fabio Nori su Canale 10, l'editore Roberto Rossi su il quotidiano La Voce, l'editrice Valentina Tacchi sulla rivista on line Il Faro, l'Avv. Stefano Di Santo sui media web Roma Capitale Magazine, la giornalista Mediaset Maria Romano Barraco su varie redazioni web, il fotoreporter Massimiliano Sebastiani su Paese Sera, il presentatore tv Anthony Peth su vari magazine web.
                  </p>
                  <p className="font-semibold text-gray-800">Per approfondimenti:</p>
                  <div className="flex flex-col gap-3">
                    <a
                      href="https://www.romacapitalemagazine.it/incontro-la-malattia-non-e-tutta-la-storia-vite-in-movimento-storie-di-cura-e-di-cio-che-ci-fa-battere-il-cuore/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-teal-50 hover:border-teal-300 transition-colors duration-200 group"
                    >
                      <div className="flex-shrink-0 w-9 h-9 bg-teal-600 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                        </svg>
                      </div>
                      <div className="flex-grow min-w-0">
                        <p className="text-sm font-medium text-gray-800 group-hover:text-teal-700 leading-snug">Incontro "La malattia non è tutta la storia"</p>
                        <p className="text-xs text-gray-500">Roma Capitale Magazine</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-gray-400 group-hover:text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                    <a
                      href="https://www.altranotizia.com/salute-la-malattia-non-e-tutta-la-storia-vite-in-movimento-storie-di-cura-e-di-cio-che-ci-fa-battere-il-cuore/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-teal-50 hover:border-teal-300 transition-colors duration-200 group"
                    >
                      <div className="flex-shrink-0 w-9 h-9 bg-teal-600 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                        </svg>
                      </div>
                      <div className="flex-grow min-w-0">
                        <p className="text-sm font-medium text-gray-800 group-hover:text-teal-700 leading-snug">SALUTE. "La malattia non è tutta la storia – Vite in movimento"</p>
                        <p className="text-xs text-gray-500">L'Altra Notizia</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-gray-400 group-hover:text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                    <a
                      href="https://www.dailymotion.com/video/xa1nyfw"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-teal-50 hover:border-teal-300 transition-colors duration-200 group"
                    >
                      <div className="flex-shrink-0 w-9 h-9 bg-teal-600 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.069A1 1 0 0121 8.82v6.36a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div className="flex-grow min-w-0">
                        <p className="text-sm font-medium text-gray-800 group-hover:text-teal-700 leading-snug">"Vite in movimento". Ascolto e condivisione con l'associazione Robin Hood Roma ODV</p>
                        <p className="text-xs text-gray-500">Video Dailymotion</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-gray-400 group-hover:text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                    <a
                      href="https://www.radioroma.it/2026/03/10/vite-in-movimento-ascolto-e-condivisione-con-lassociazione-robin-hood-roma-odv/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-teal-50 hover:border-teal-300 transition-colors duration-200 group"
                    >
                      <div className="flex-shrink-0 w-9 h-9 bg-teal-600 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                        </svg>
                      </div>
                      <div className="flex-grow min-w-0">
                        <p className="text-sm font-medium text-gray-800 group-hover:text-teal-700 leading-snug">Vite in movimento: ascolto e condivisione con Robin Hood Roma ODV</p>
                        <p className="text-xs text-gray-500">Radio Roma</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-gray-400 group-hover:text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                    <a
                      href="https://www.romadailynews.it/eventi/vite-in-movimento-la-malattia-non-e-tutta-la-storia-0925267/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-teal-50 hover:border-teal-300 transition-colors duration-200 group"
                    >
                      <div className="flex-shrink-0 w-9 h-9 bg-teal-600 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                        </svg>
                      </div>
                      <div className="flex-grow min-w-0">
                        <p className="text-sm font-medium text-gray-800 group-hover:text-teal-700 leading-snug">Vite in movimento, la malattia non è tutta la storia</p>
                        <p className="text-xs text-gray-500">RomaDailyNews</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-gray-400 group-hover:text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                    <a
                      href="https://www.paeseroma.it/attualita/2026/03/12/la-malattia-non-e-tutta-la-storia-a-roma-voci-e-progetti-per-i-pazienti-ematologici/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-teal-50 hover:border-teal-300 transition-colors duration-200 group"
                    >
                      <div className="flex-shrink-0 w-9 h-9 bg-teal-600 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                        </svg>
                      </div>
                      <div className="flex-grow min-w-0">
                        <p className="text-sm font-medium text-gray-800 group-hover:text-teal-700 leading-snug">"La malattia non è tutta la storia": a Roma voci e progetti per i pazienti ematologici</p>
                        <p className="text-xs text-gray-500">PaeseRoma</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-gray-400 group-hover:text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                    <a
                      href="https://www.ilfaroinrete.it/2026/03/12/associazione-robin-hood-roma-odvrobin-hood/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-teal-50 hover:border-teal-300 transition-colors duration-200 group"
                    >
                      <div className="flex-shrink-0 w-9 h-9 bg-teal-600 rounded-full flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                        </svg>
                      </div>
                      <div className="flex-grow min-w-0">
                        <p className="text-sm font-medium text-gray-800 group-hover:text-teal-700 leading-snug">Associazione Robin Hood Roma ODV</p>
                        <p className="text-xs text-gray-500">Il Faro in Rete</p>
                      </div>
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-4 w-4 text-gray-400 group-hover:text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="p-3 flex justify-end border-t border-gray-200 bg-white">
                <button
                  onClick={() => setIsMediaModalOpen(false)}
                  className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modale Voci dei lettori - Premio Strega 2026 */}
        {isVociLettoriModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && setIsVociLettoriModalOpen(false)}
            role="dialog"
            aria-modal="true"
            aria-labelledby="voci-lettori-modal-title"
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col max-h-[90vh]"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="bg-emerald-700 px-6 py-5 text-white relative">
                <button
                  onClick={() => setIsVociLettoriModalOpen(false)}
                  className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                  aria-label="Chiudi modal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
                <h3 className="text-2xl font-bold" id="voci-lettori-modal-title">Voci dei lettori</h3>
                <p className="text-sm opacity-90 mt-1">Premio Strega 2026 – Gruppo di Lettura Robin Hood Roma ODV</p>
              </div>
              <div className="p-6 overflow-y-auto">
                <p className="text-gray-700 leading-relaxed mb-6">
                  Ogni percorso lascia qualcosa di diverso in chi lo vive. Questi commenti sono il segno più autentico di ciò che il progetto ha saputo generare: non solo un’occasione per leggere e discutere i libri candidati al Premio Strega, ma un’esperienza di crescita culturale e umana che molti desiderano continuare a vivere anche negli anni futuri.
                </p>
                <ul className="flex flex-col gap-4">
                  {[
                    "Questa esperienza mi ha ricordato che leggere insieme significa andare ben oltre i libri: il vero valore è stato il confronto con persone capaci di ascoltare e condividere punti di vista diversi (Marco M.).",
                    "Alla fine del percorso ci siamo accorti di aver formato un bel gruppo, abbiamo discusso, ci siamo confrontati, è stato molto bello! (Silvia F.)",
                    "All’inizio pensavo soprattutto alla sfida di leggere tutti i romanzi; alla fine mi sono reso conto che quello che ho più apprezzato sono state le serate di discussione, tutte diverse e stimolanti, direi splendide (Dario S.)",
                    "Non leggevo da un po’ di anni. Gli incontri sono stati un appuntamento che aspettavo con piacere nella solitudine dell’isolamento in ospedale: ogni discussione mi ha lasciato spunti di riflessione e il desiderio di continuare a leggere (Paola B.).",
                    "Ho apprezzato il clima di rispetto e di libertà con cui ciascuno ha potuto esprimere le proprie idee. È raro trovare uno spazio in cui il dialogo sia così autentico (Sara L.).",
                    "Pur essendo un percorso impegnativo (anche per il fuso orario e gli impegni di lavoro), ne è valsa la pena. Quello che ci ha dato questa esperienza, non ce lo può togliere nessuno (Flavia C.)",
                    "La competenza e la discrezione del facilitatore, unite all’accurata organizzazione, hanno reso ogni incontro coinvolgente senza mai togliere spazio ai partecipanti (Maria Cristina G.).",
                    "Anche quando ho preferito ascoltare piuttosto che intervenire, mi sono sentita parte integrante del gruppo. È stato bello sentirsi accolto e coinvolto (Rosalia V).",
                    "Questo percorso mi ha fatto cambiare idea su diversi libri e, soprattutto, mi ha insegnato quanto il confronto con gli altri possa arricchire la lettura personale (Alida).",
                    "Spero davvero che questa esperienza continui negli anni: sarebbe un peccato interrompere un percorso che ha creato legami, stimolato il pensiero e alimentato la passione per la letteratura (Anna Maria T.)."
                  ].map((commento, index) => (
                    <li
                      key={index}
                      className="bg-gray-50 border-l-4 border-emerald-700 rounded-r-lg p-4 text-gray-700 leading-relaxed"
                    >
                      {commento}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="p-3 flex justify-end border-t border-gray-200 bg-white">
                <button
                  onClick={() => setIsVociLettoriModalOpen(false)}
                  className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modale La mia storia di lettore - Premio Strega 2026 */}
        {isStoriaLettoreModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && setIsStoriaLettoreModalOpen(false)}
            role="dialog"
            aria-modal="true"
            aria-labelledby="storia-lettore-modal-title"
          >
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col max-h-[90vh]"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="bg-green-700 px-6 py-5 text-white relative">
                <button
                  onClick={() => setIsStoriaLettoreModalOpen(false)}
                  className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                  aria-label="Chiudi modal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
                <h3 className="text-2xl font-bold" id="storia-lettore-modal-title">La mia storia di lettore</h3>
                <p className="text-sm opacity-90 mt-1">Storia delle mie letture – di Claudio Cherin</p>
              </div>
              <div className="p-6 overflow-y-auto">
                <div className="flex flex-col gap-4 text-gray-700 leading-relaxed">
                  <p>Presto fu tardi. A quattordici anni era troppo tardi. Cosa, questa, che avrei scoperto anni dopo. Ignoravo cosa fosse l’Ematologia. E che il busto del tizio, nella sala d’attesa, fosse Ippocrate. Per me doveva essere Platone perché era il solo di cui avevo sentito parlare.</p>
                  <p>Allora, non avevo molte certezze. Non avevo vissuto o scoperto quasi nulla del mondo. Molte cose me le ero immaginate, altre le avevo solo lette o mi erano state raccontate. Mi trovavo nella sezione di Ematologia del Policlinico Umberto I di Roma, perché c’era qualcosa che non tornava nelle mie analisi.</p>
                  <p>Aspettare il proprio turno all’accettazione, sotto il volto accigliato di Ippocrate, era divenuta una consuetudine. Come portare con me tascabili. Agatha Christie, Franz Kafka, Aristofane. O dividere la mia vita in due. Da una parte c’erano l’attesa e le storie, gli scorci di cielo e il villino anni Venti – nel quale tuttora è ubicata la sezione di Ematologia −; dall’altra il liceo − sul quale avevo fantasticato molto – le sue rigide (e arbitrarie) regole e il silenzio rigoroso da Controriforma.</p>
                  <p>Leggevo tutto quello che mi capitava. Andavo per titoli. Più un titolo mi sembrava evocativo più ne ero attratto. Così ho iniziato a leggere veramente, passando ore e ore immaginando personaggi, ambienti e volti. No, in quel periodo la lettura non era ancora diventata un rifugio. Lo sarebbe diventata alla fine di quelle lunghe attese. Quando il volto d’Ippocrate si sarebbe rasserenato. E la vita sarebbe tornata regolare. Entrare nelle parole era un modo per non sentire l’arcigna professoressa di lettere. Né i compagni con cui non avevo molto da spartire. Da allora sarei stato affetto da quella sensazione che ancora oggi mi accompagna: l’essere in bilico, l’essere estraneo al mondo che mi circonda. E sentirmi a casa solo nelle lande desolate d’Islanda dove il cielo è d’un azzurro purissimo e le montagne raccontano storie di solitudine e sopportazione.</p>
                  <p>A quei tempi, non immaginavo che, un giorno, avrei incontrato degli scrittori che mi avrebbero accompagnato per tutta la vita e di cui non avrei potuto fare a meno (come Giorgio Bassani o Virginia Woolf, Charles Dickens, Cesare Pavese o Alberto Moravia); altri che mi avrebbero raccontato il dolore. E quelli, come il danese Peter Høeg, che mi avrebbero aperto la strada per luoghi che, anni più tardi, avrei visitato.</p>
                  <p>Sopravvissuto ‘alla paura del cielo’ – la sensazione di stupore e di tremore che si prova quando si capisce che le regole bigotte e rigide del liceo non hanno nessun senso nella vita reale – passavo molto tempo nella biblioteca del mio quartiere. I bibliotecari mi chiedevano se e come facessi a leggere con tale costanza. Io imbarazzato rispondevo con un soffro d’insonnia, con un non guardo la televisione. Ad un certo punto è bastato un laconico: sono uno studente di lettere.</p>
                  <p>Non immaginavo che un giorno di scrittori ne avrei incontrati per davvero. E con loro avrei potuto parlare. Frequentando un seminario di letteratura contemporanea mi ‘ammollarono’ un libro poderoso di Melania G. Mazzucco. La conoscevo di nome. Avevo letto degli articoli sul suo primo, fortunato romanzo, <em>Il bacio della Medusa</em>. Avevo immaginato dalle poche informazioni presenti negli articoli una storia, che mi avrebbe deluso. Come avevano fatto altre. Ma dovetti ricredermi una volta finito il romanzo che la professoressa mi aveva dato da leggere. Allora non avevo molti soldi per permettermi di comprare gli altri libri della scrittrice. Di copie tascabili neanche l’ombra, la mia biblioteca sembrava ignorarla. In una libreria che stava per fallire trovai alcuni suoi romanzi a pochi euro. Questo non poté che rafforzare l’idea che avevo avuto con il primo libro letto. Entrai subito in sintonia con la storia e il ritmo delle parole, da cui non riuscii a staccarmi. Mi colpiva il mondo in cui l’autrice creava atmosfere. Ci fu un incontro. E a me toccò presentarla. Ricordo che portava una camicetta bianca ricamata, una gonna lunga a fiori, un filo di perle; aveva l’aria severa. Avevo preso degli appunti, ma avevo paura che mi sarei confuso o che avrei finito per dire sciocchezze. Ricordo ancora il ‘bravo!’ che la scrittrice mi disse nel mezzo della mia presentazione. E la dedica che mi scrisse affermando che ero ‘promettente’. Mi ricordo che parlammo. Io me ne uscii con un’imbarazzante ‘anche lei è molto promettente come scrittrice’. La rincontrai alla serata finale allo Strega. Venne lei a salutarmi. Non pensavo che si ricordasse di me.</p>
                  <p>Dopo la laurea continuai a leggere in attesa di qualcosa. Di un dottorato che non sarebbe giunto, di un lavoro. Di qualcosa insomma. Ero iscritto ad un master in Filosofia. L’unica cosa che mi si prospettò di nuovo fu attendere in una sala d’attesa referti. Altri mesi di letture intense. Sguardi rivolti agli scorci di cielo e una vita scombussolata per l’ennesima volta. Nel frattempo, il mio modo di leggere era diventato molto più consapevole, ma anche onnivoro. Lessi quasi tutto Nice, il catalogo della casa editrice Adelphi, Iperborea. E i libri della Mazzucco, che dalla sera dello Strega chiamavo “Melania”. Una volta la incontrai anche a Palazzo Barberini; un’altra, con alcuni della biblioteca di quartiere, andammo ad ascoltare una sua presentazione. Ricordo che le dissi che mi era mancata molto la sua voce. Il che la fece sorridere imbarazzata.</p>
                  <p>Nel frattempo, la casa in cui vivevo in attesa di un futuro migliore era diventata un ricettacolo di libri e di quadri comprati nei mercatini. I libri non erano mai abbastanza. Li accumulavo un po’ ovunque. Comodini, tavoli, sedie. Bazzicavo librerie a metà prezzo. E quando aprivo un qualche romanzo i personaggi non solo prendevano forma, ma diventavano reali. Tanto che sarei andato alla loro ricerca come aveva fatto Gregor Von Rezzori, l’ultimo scrittore della Mitteleuropa, che era partito per cercare a Jonesboro, a pochi chilometri da Atlanta, la capitale dello stato americano della Georgia, la piantagione degli O’Hara, protagonisti del celebre <em>Via col vento</em>.</p>
                  <p>Due anni fa, in uno dei miei incontri con la Dottoressa Giona – una delle dottoresse che avevo conosciuto a Ematologia − parlammo di un progetto, che era fuori dalle mie possibilità. Troppo concreto per me che vivo tra le nuvole… Era da tempo che volevo sentirmi in qualche modo utile. Speravo nelle Gps e nel fatto che, ad un certo punto, la scuola in ospedale di Ematologia mi avrebbe chiamato. Speravo di poter dare il mio contributo insegnando o quanto meno facendo appassionare i bambini malati alle storie. Per me erano state fondamentali. Ma ciò non avvenne, purtroppo. Continuavo a frequentare Ematologia. Un giorno parlando con la dottoressa Giona le proposi di costituire un gruppo di lettura. Usare, insomma, la formula che avevo sperimentato come studente all’Università mi sembrava interessante. La dottoressa sapeva del mio amore per i libri. E del fatto che scrivevo per riviste accademiche e rivedevo articoli in redazioni nell’aria impregnata dall’odore delle puzzolentissime Winston. Così le proposi di mandare una lettera alla Fondazione Bellonci. Dai tempi dell’Università leggevo i libri delle dozzine dello Strega ogni anno, perché era il mondo, quello del Premio Strega e delle case editrici, in cui sarei voluto trovare un lavoro.</p>
                  <p>Una volta scritta la lettera nella quale si presentava il progetto dell’Associazione – la Robin Hood Roma ODV − e la costituzione di un gruppo di lettura, non avvenne molto. Così desistemmo. Sembrava che non interessasse a nessuno promuovere la lettura in ospedale. Poi, ad aprile di quest’anno, la Fondazione Bellonci contattò l’Associazione, di cui la Dottoressa Giona è la presidentessa, e la informarono che avevano accolto la nostra proposta.</p>
                  <p>Così ha preso vita il gruppo di lettura che io e la Dottoressa Giona abbiamo capitanato. Con successo. Diverse le persone che vi hanno partecipato. Diverse per età, per studi, per sensibilità e formazione. Ognuno ha avuto la possibilità di esprimere le proprie idee e di dare una valutazione sui libri che si andavano via via leggendo. Poi durante ogni serata ognuno ha potuto mettere in evidenza i punti di forza e di debolezza del testo preso in esame. Di solito nei gruppi di lettura c’è sempre qualcuno che prevarica l’altro. Mi è capitato. Mi sono ritrovato in un gruppo di insegnanti di lettere a leggere classici. Io restato in silenzio mentre gli insegnanti discutevano animatamente (per non dire che si scannavano) e finivano per andare sul personale e litigare. In questo caso, invece, abbiamo messo in chiaro quali erano le regole da seguire. E ci si è confrontati. Non abbiamo litigato. Abbiamo esposto le nostre visioni. Quello che ho cercato di fare io è stato dare delle informazioni su alcuni autori, su correnti e modi di pensare la letteratura (la famosa morte del romanzo, di cui parlava Giorgio Barberi Squarotti; il ruolo della letteratura triestina; che cosa si intende per ‘divertimento letterario’ e altro).</p>
                  <p>Alcide Pierantozzi, Matteo Nucci e Nadeesha Uyangoda sono stati i libri che abbiamo amato di più. Devo dire che anche se non molti l’hanno apprezzato, ho avuto modo di rivalutare Christian Raimo. Avevo letto altri suoi romanzi, ma non avevano suscitato in me nessun interesse. Lo ritenevo uno scrittore-sociologo sulla scia delle idee del critico Walter Pedullà. Ho trovato <em>Storia del colore</em> un romanzo in cui si racconta in modo molto pudico e delicato la morte di un padre e di un mondo (quello della colorazione delle pellicole del cinema). Alla fine, abbiamo votato. Gli Amici della domenica si sono riuniti e hanno decretato il Premio Strega 2026.</p>
                  <p>Credo di essere riuscito a fare qualcosa che, in altri momenti, non sono riuscito a fare: dare il mio contributo per alleviare le sofferenze di quanti si trovano nel mondo dell’attesa. E della malattia. Per la prima volta mi sembra che il mio amore per la letteratura e il mio ‘leggo per resistere’ al mondo − che è ostile e si perde nella melma della banalità del male – si sia rivelato utile.</p>
                  <p>Perché scrivere <em>storia delle mie letture?</em> Forse perché ogni tanto c’è bisogno di fare il punto della situazione. Di ripensare alla lettura come una possibilità. E di chiedersi da dove nasca questo bisogno e perché sia per alcuni così necessaria. Leggere è un modo per andare avanti, per difendersi dalla stupidità o dal tempo lungo delle attese. Per vivere altre vite e avere altri sguardi. Ma anche un modo per pensare a come i libri riletti a distanza di anni dicano sempre cose nuove e diverse. O solo per il gusto di raccontarsi una storia. La propria. Come un’autobiografia camuffata, cosa chiara a Elias Canetti che ne scrisse in una lettera a Roberto Calasso. Associare cioè un libro ad un particolare evento della propria esistenza. O semplicemente per raccontare un piccolo sogno, che si è avverato.</p>
                </div>
              </div>
              <div className="p-3 flex justify-end border-t border-gray-200 bg-white">
                <button
                  onClick={() => setIsStoriaLettoreModalOpen(false)}
                  className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modale Galleria foto - 7 marzo 2026 */}
        {/* Photo Gallery Modal */}
        {isGalleryOpen && galleryImages.length > 0 && (
          <div
            className="fixed inset-0 bg-black bg-opacity-95 z-[60] flex items-center justify-center animate-fadeIn"
            onClick={closeGallery}
            onKeyDown={handleGalleryKeyDown}
            role="dialog"
            aria-modal="true"
            aria-label="Galleria fotografica"
            tabIndex={0}
          >
            {/* Close button */}
            <button
              onClick={closeGallery}
              className="absolute top-4 right-4 z-10 w-12 h-12 flex items-center justify-center bg-white/10 text-white rounded-full hover:bg-white/20 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white backdrop-blur-sm"
              aria-label="Chiudi galleria"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>

            {/* Image counter */}
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-white/10 text-white px-4 py-2 rounded-full backdrop-blur-sm font-medium">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>

            {/* Main image container */}
            <div 
              className="relative w-full h-full flex items-center justify-center p-4"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Previous button */}
              {galleryImages.length > 1 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    prevImage();
                  }}
                  className="absolute left-4 z-10 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-white/10 text-white rounded-full hover:bg-white/20 transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-white backdrop-blur-sm"
                  aria-label="Immagine precedente"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 md:h-8 md:w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
              )}

              {/* Image */}
              <img
                src={galleryImages[currentImageIndex]}
                alt={`Foto ${currentImageIndex + 1}`}
                className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl animate-scaleIn"
                onClick={(e) => e.stopPropagation()}
              />

              {/* Next button */}
              {galleryImages.length > 1 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    nextImage();
                  }}
                  className="absolute right-4 z-10 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-white/10 text-white rounded-full hover:bg-white/20 transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-white backdrop-blur-sm"
                  aria-label="Immagine successiva"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 md:h-8 md:w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              )}
            </div>

            {/* Thumbnail navigation (optional, only if more than 1 image) */}
            {galleryImages.length > 1 && (
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-white/10 p-2 rounded-lg backdrop-blur-sm max-w-[90vw] overflow-x-auto">
                {galleryImages.map((img, index) => (
                  <button
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex(index);
                    }}
                    className={`w-16 h-16 rounded-md overflow-hidden flex-shrink-0 transition-all duration-300 ${
                      index === currentImageIndex 
                        ? 'ring-2 ring-white scale-110' 
                        : 'opacity-60 hover:opacity-100'
                    }`}
                  >
                    <img
                      src={img}
                      alt={`Miniatura ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Scroll to top button */}
        {showScrollTop && (
          <button
            onClick={scrollToTop}
            className="fixed right-6 bottom-6 p-3 rounded-full bg-accent text-white shadow-lg hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 transform transition-all duration-300 hover:scale-110 z-40 animate-fadeIn"
            aria-label="Torna all'inizio della pagina"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 11l7-7 7 7M5 19l7-7 7 7" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

// Define animations in CSS
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes scaleIn {
    from { transform: scale(0.95); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
  
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-in-out forwards;
  }
  
  .animate-scaleIn {
    animation: scaleIn 0.3s ease-out forwards;
  }
`;
document.head.appendChild(style);

export default Eventi;
